var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/api/resources/analytics/types/EventsResponse.ts
var init_EventsResponse = __esm({
  "src/api/resources/analytics/types/EventsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/ViewEvent.ts
var init_ViewEvent = __esm({
  "src/api/resources/analytics/types/ViewEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/GuideRatedEvent.ts
var init_GuideRatedEvent = __esm({
  "src/api/resources/analytics/types/GuideRatedEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/SearchEvent.ts
var init_SearchEvent = __esm({
  "src/api/resources/analytics/types/SearchEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/FeedbackEvent.ts
var init_FeedbackEvent = __esm({
  "src/api/resources/analytics/types/FeedbackEvent.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/DashboardToken.ts
var init_DashboardToken = __esm({
  "src/api/resources/analytics/types/DashboardToken.ts"() {
    "use strict";
  }
});

// src/api/resources/analytics/types/index.ts
var init_types = __esm({
  "src/api/resources/analytics/types/index.ts"() {
    "use strict";
    init_EventsResponse();
    init_ViewEvent();
    init_GuideRatedEvent();
    init_SearchEvent();
    init_FeedbackEvent();
    init_DashboardToken();
  }
});

// src/api/resources/analytics/client/getEventData.ts
var getEventData_exports = {};
__export(getEventData_exports, {
  Error: () => Error2
});
var Error2;
var init_getEventData = __esm({
  "src/api/resources/analytics/client/getEventData.ts"() {
    "use strict";
    init_src();
    Error2 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.analytics.getEventData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/analytics/client/getIdentity.ts
var getIdentity_exports = {};
__export(getIdentity_exports, {
  Error: () => Error3
});
var Error3;
var init_getIdentity = __esm({
  "src/api/resources/analytics/client/getIdentity.ts"() {
    "use strict";
    init_src();
    Error3 = {
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.analytics.getIdentity.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/analytics/client/index.ts
var init_client = __esm({
  "src/api/resources/analytics/client/index.ts"() {
    "use strict";
    init_getEventData();
    init_getIdentity();
  }
});

// src/api/resources/analytics/index.ts
var analytics_exports = {};
__export(analytics_exports, {
  getEventData: () => getEventData_exports,
  getIdentity: () => getIdentity_exports
});
var init_analytics = __esm({
  "src/api/resources/analytics/index.ts"() {
    "use strict";
    init_types();
    init_client();
  }
});

// src/api/resources/audio/types/Transcript.ts
var init_Transcript = __esm({
  "src/api/resources/audio/types/Transcript.ts"() {
    "use strict";
  }
});

// src/api/resources/audio/types/index.ts
var init_types2 = __esm({
  "src/api/resources/audio/types/index.ts"() {
    "use strict";
    init_Transcript();
  }
});

// src/api/resources/audio/client/requests/index.ts
var init_requests = __esm({
  "src/api/resources/audio/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/audio/client/getTranscript.ts
var getTranscript_exports = {};
__export(getTranscript_exports, {
  Error: () => Error4
});
var Error4;
var init_getTranscript = __esm({
  "src/api/resources/audio/client/getTranscript.ts"() {
    "use strict";
    init_src();
    Error4 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.getTranscript.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.getTranscript.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/saveAudio.ts
var saveAudio_exports = {};
__export(saveAudio_exports, {
  Error: () => Error5
});
var Error5;
var init_saveAudio = __esm({
  "src/api/resources/audio/client/saveAudio.ts"() {
    "use strict";
    init_src();
    Error5 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.saveAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/saveGuideAudio.ts
var saveGuideAudio_exports = {};
__export(saveGuideAudio_exports, {
  Error: () => Error6
});
var Error6;
var init_saveGuideAudio = __esm({
  "src/api/resources/audio/client/saveGuideAudio.ts"() {
    "use strict";
    init_src();
    Error6 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.audio.saveGuideAudio.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/audio/client/index.ts
var init_client2 = __esm({
  "src/api/resources/audio/client/index.ts"() {
    "use strict";
    init_requests();
    init_getTranscript();
    init_saveAudio();
    init_saveGuideAudio();
  }
});

// src/api/resources/audio/index.ts
var audio_exports = {};
__export(audio_exports, {
  getTranscript: () => getTranscript_exports,
  saveAudio: () => saveAudio_exports,
  saveGuideAudio: () => saveGuideAudio_exports
});
var init_audio = __esm({
  "src/api/resources/audio/index.ts"() {
    "use strict";
    init_types2();
    init_client2();
  }
});

// src/api/resources/baseTypes/types/Id.ts
function Id(value) {
  return value;
}
var init_Id = __esm({
  "src/api/resources/baseTypes/types/Id.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/PresignedUrl.ts
var init_PresignedUrl = __esm({
  "src/api/resources/baseTypes/types/PresignedUrl.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/SimpleResponse.ts
var init_SimpleResponse = __esm({
  "src/api/resources/baseTypes/types/SimpleResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/GetChildrenRequest.ts
var init_GetChildrenRequest = __esm({
  "src/api/resources/baseTypes/types/GetChildrenRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/IdRequest.ts
var init_IdRequest = __esm({
  "src/api/resources/baseTypes/types/IdRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/Token.ts
var init_Token = __esm({
  "src/api/resources/baseTypes/types/Token.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/VideoFormat.ts
var init_VideoFormat = __esm({
  "src/api/resources/baseTypes/types/VideoFormat.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/S3Object.ts
var init_S3Object = __esm({
  "src/api/resources/baseTypes/types/S3Object.ts"() {
    "use strict";
  }
});

// src/api/resources/baseTypes/types/index.ts
var init_types3 = __esm({
  "src/api/resources/baseTypes/types/index.ts"() {
    "use strict";
    init_Id();
    init_PresignedUrl();
    init_SimpleResponse();
    init_GetChildrenRequest();
    init_IdRequest();
    init_Token();
    init_VideoFormat();
    init_S3Object();
  }
});

// src/api/resources/baseTypes/index.ts
var baseTypes_exports = {};
__export(baseTypes_exports, {
  Id: () => Id
});
var init_baseTypes = __esm({
  "src/api/resources/baseTypes/index.ts"() {
    "use strict";
    init_types3();
  }
});

// src/api/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts
var init_MoveCollectionRequest = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/types/index.ts
var init_types4 = __esm({
  "src/api/resources/collections/resources/collectionMutations/types/index.ts"() {
    "use strict";
    init_MoveCollectionRequest();
  }
});

// src/api/resources/collections/resources/collectionMutations/client/requests/index.ts
var init_requests2 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionMutations/client/createCollection.ts
var createCollection_exports = {};
__export(createCollection_exports, {
  Error: () => Error7
});
var Error7;
var init_createCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/createCollection.ts"() {
    "use strict";
    init_src();
    Error7 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.createCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/updateCollection.ts
var updateCollection_exports = {};
__export(updateCollection_exports, {
  Error: () => Error8
});
var Error8;
var init_updateCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/updateCollection.ts"() {
    "use strict";
    init_src();
    Error8 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.updateCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/moveCollection.ts
var moveCollection_exports = {};
__export(moveCollection_exports, {
  Error: () => Error9
});
var Error9;
var init_moveCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/moveCollection.ts"() {
    "use strict";
    init_src();
    Error9 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.moveCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/deleteCollection.ts
var deleteCollection_exports = {};
__export(deleteCollection_exports, {
  Error: () => Error10
});
var Error10;
var init_deleteCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/deleteCollection.ts"() {
    "use strict";
    init_src();
    Error10 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.deleteCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/reorderCollection.ts
var reorderCollection_exports = {};
__export(reorderCollection_exports, {
  Error: () => Error11
});
var Error11;
var init_reorderCollection = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/reorderCollection.ts"() {
    "use strict";
    init_src();
    Error11 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.reorderCollection.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts
var setCollectionVisibility_exports = {};
__export(setCollectionVisibility_exports, {
  Error: () => Error12
});
var Error12;
var init_setCollectionVisibility = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts"() {
    "use strict";
    init_src();
    Error12 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(
              this,
              visitor
            );
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/index.ts
var init_client3 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/index.ts"() {
    "use strict";
    init_requests2();
    init_createCollection();
    init_updateCollection();
    init_moveCollection();
    init_deleteCollection();
    init_reorderCollection();
    init_setCollectionVisibility();
  }
});

// src/api/resources/collections/resources/collectionMutations/index.ts
var collectionMutations_exports = {};
__export(collectionMutations_exports, {
  createCollection: () => createCollection_exports,
  deleteCollection: () => deleteCollection_exports,
  moveCollection: () => moveCollection_exports,
  reorderCollection: () => reorderCollection_exports,
  setCollectionVisibility: () => setCollectionVisibility_exports,
  updateCollection: () => updateCollection_exports
});
var init_collectionMutations = __esm({
  "src/api/resources/collections/resources/collectionMutations/index.ts"() {
    "use strict";
    init_types4();
    init_client3();
  }
});

// src/api/resources/collections/resources/collectionTypes/types/CollectionInput.ts
var init_CollectionInput = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/CollectionInput.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/Collection.ts
var init_Collection = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/Collection.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts
var init_GetCollectionsResponse = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts
var init_GetAllChildrenResponse = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/resources/collectionTypes/types/index.ts
var init_types5 = __esm({
  "src/api/resources/collections/resources/collectionTypes/types/index.ts"() {
    "use strict";
    init_CollectionInput();
    init_Collection();
    init_GetCollectionsResponse();
    init_GetAllChildrenResponse();
  }
});

// src/api/resources/collections/resources/collectionTypes/index.ts
var collectionTypes_exports = {};
var init_collectionTypes = __esm({
  "src/api/resources/collections/resources/collectionTypes/index.ts"() {
    "use strict";
    init_types5();
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getCollections.ts
var getCollections_exports = {};
__export(getCollections_exports, {
  Error: () => Error13
});
var Error13;
var init_getCollections = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    Error13 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getAllChildren.ts
var getAllChildren_exports = {};
__export(getAllChildren_exports, {
  Error: () => Error14
});
var Error14;
var init_getAllChildren = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    Error14 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getAllCollections.ts
var getAllCollections_exports = {};
__export(getAllCollections_exports, {
  Error: () => Error15
});
var Error15;
var init_getAllCollections = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    Error15 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/getPath.ts
var getPath_exports = {};
__export(getPath_exports, {
  Error: () => Error16
});
var Error16;
var init_getPath = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    Error16 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.collections.collectionQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/index.ts
var init_client4 = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/index.ts"() {
    "use strict";
    init_getCollections();
    init_getAllChildren();
    init_getAllCollections();
    init_getPath();
  }
});

// src/api/resources/collections/resources/collectionQueries/index.ts
var collectionQueries_exports = {};
__export(collectionQueries_exports, {
  getAllChildren: () => getAllChildren_exports,
  getAllCollections: () => getAllCollections_exports,
  getCollections: () => getCollections_exports,
  getPath: () => getPath_exports
});
var init_collectionQueries = __esm({
  "src/api/resources/collections/resources/collectionQueries/index.ts"() {
    "use strict";
    init_client4();
  }
});

// src/api/resources/collections/resources/index.ts
var init_resources = __esm({
  "src/api/resources/collections/resources/index.ts"() {
    "use strict";
    init_collectionMutations();
    init_types4();
    init_collectionTypes();
    init_types5();
    init_collectionQueries();
    init_requests2();
  }
});

// src/api/resources/collections/client/index.ts
var init_client5 = __esm({
  "src/api/resources/collections/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/collections/index.ts
var collections_exports = {};
__export(collections_exports, {
  collectionMutations: () => collectionMutations_exports,
  collectionQueries: () => collectionQueries_exports,
  collectionTypes: () => collectionTypes_exports
});
var init_collections = __esm({
  "src/api/resources/collections/index.ts"() {
    "use strict";
    init_resources();
    init_client5();
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts
var init_InitiateCreateGuideRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts
var init_InitiateCreateVideoGuideResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts
var init_MoveGuideRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/PlainDocRequest.ts
var init_PlainDocRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/PlainDocRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts
var init_GenerateVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/GenerateEditedVideoRequest.ts
var init_GenerateEditedVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/GenerateEditedVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts
var init_GenerateBookendsVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/UpdateVideoEditsRequest.ts
var init_UpdateVideoEditsRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/UpdateVideoEditsRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts
var init_UploadChunkRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts
var init_CompileVideoRequest = __esm({
  "src/api/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts
var init_CompileVideoResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts
var init_ExportGuideResponse = __esm({
  "src/api/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/types/index.ts
var init_types6 = __esm({
  "src/api/resources/guides/resources/guideMutations/types/index.ts"() {
    "use strict";
    init_InitiateCreateGuideRequest();
    init_InitiateCreateVideoGuideResponse();
    init_MoveGuideRequest();
    init_PlainDocRequest();
    init_GenerateVideoRequest();
    init_GenerateEditedVideoRequest();
    init_GenerateBookendsVideoRequest();
    init_UpdateVideoEditsRequest();
    init_UploadChunkRequest();
    init_CompileVideoRequest();
    init_CompileVideoResponse();
    init_ExportGuideResponse();
  }
});

// src/api/resources/guides/resources/guideMutations/client/requests/index.ts
var init_requests3 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideMutations/client/generateVideo.ts
var generateVideo_exports = {};
__export(generateVideo_exports, {
  Error: () => Error17
});
var Error17;
var init_generateVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/generateVideo.ts"() {
    "use strict";
    init_src();
    Error17 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/generateEditedVideo.ts
var generateEditedVideo_exports = {};
__export(generateEditedVideo_exports, {
  Error: () => Error18
});
var Error18;
var init_generateEditedVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/generateEditedVideo.ts"() {
    "use strict";
    init_src();
    Error18 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateEditedVideo.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateEditedVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateEditedVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/generateBookendsVideo.ts
var generateBookendsVideo_exports = {};
__export(generateBookendsVideo_exports, {
  Error: () => Error19
});
var Error19;
var init_generateBookendsVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/generateBookendsVideo.ts"() {
    "use strict";
    init_src();
    Error19 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateBookendsVideo.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateBookendsVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.generateBookendsVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/enhance.ts
var enhance_exports = {};
__export(enhance_exports, {
  Error: () => Error20
});
var Error20;
var init_enhance = __esm({
  "src/api/resources/guides/resources/guideMutations/client/enhance.ts"() {
    "use strict";
    init_src();
    Error20 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.enhance.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.enhance.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/enhanceVideoTranscript.ts
var enhanceVideoTranscript_exports = {};
__export(enhanceVideoTranscript_exports, {
  Error: () => Error21
});
var Error21;
var init_enhanceVideoTranscript = __esm({
  "src/api/resources/guides/resources/guideMutations/client/enhanceVideoTranscript.ts"() {
    "use strict";
    init_src();
    Error21 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.enhanceVideoTranscript.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.enhanceVideoTranscript.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/getLoomToken.ts
var getLoomToken_exports = {};
__export(getLoomToken_exports, {
  Error: () => Error22
});
var Error22;
var init_getLoomToken = __esm({
  "src/api/resources/guides/resources/guideMutations/client/getLoomToken.ts"() {
    "use strict";
    init_src();
    Error22 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.getLoomToken.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.getLoomToken.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/startCreateGuide.ts
var startCreateGuide_exports = {};
__export(startCreateGuide_exports, {
  Error: () => Error23
});
var Error23;
var init_startCreateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/startCreateGuide.ts"() {
    "use strict";
    init_src();
    Error23 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.startCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.startCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishCreateGuide.ts
var finishCreateGuide_exports = {};
__export(finishCreateGuide_exports, {
  Error: () => Error24
});
var Error24;
var init_finishCreateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishCreateGuide.ts"() {
    "use strict";
    init_src();
    Error24 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts
var initiateCreateGuide_exports = {};
__export(initiateCreateGuide_exports, {
  Error: () => Error25
});
var Error25;
var init_initiateCreateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts"() {
    "use strict";
    init_src();
    Error25 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/initiateCreateVideoGuide.ts
var initiateCreateVideoGuide_exports = {};
__export(initiateCreateVideoGuide_exports, {
  Error: () => Error26
});
var Error26;
var init_initiateCreateVideoGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/initiateCreateVideoGuide.ts"() {
    "use strict";
    init_src();
    Error26 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateVideoGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.initiateCreateVideoGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/uploadImage.ts
var uploadImage_exports = {};
__export(uploadImage_exports, {
  Error: () => Error27
});
var Error27;
var init_uploadImage = __esm({
  "src/api/resources/guides/resources/guideMutations/client/uploadImage.ts"() {
    "use strict";
    init_src();
    Error27 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadImage.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts
var uploadVideoChunk_exports = {};
__export(uploadVideoChunk_exports, {
  Error: () => Error28
});
var Error28;
var init_uploadVideoChunk = __esm({
  "src/api/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts"() {
    "use strict";
    init_src();
    Error28 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.uploadVideoChunk.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/compileVideo.ts
var compileVideo_exports = {};
__export(compileVideo_exports, {
  Error: () => Error29
});
var Error29;
var init_compileVideo = __esm({
  "src/api/resources/guides/resources/guideMutations/client/compileVideo.ts"() {
    "use strict";
    init_src();
    Error29 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.compileVideo.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateGuideData.ts
var updateGuideData_exports = {};
__export(updateGuideData_exports, {
  Error: () => Error30
});
var Error30;
var init_updateGuideData = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateGuideData.ts"() {
    "use strict";
    init_src();
    Error30 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateVideoEdits.ts
var updateVideoEdits_exports = {};
__export(updateVideoEdits_exports, {
  Error: () => Error31
});
var Error31;
var init_updateVideoEdits = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateVideoEdits.ts"() {
    "use strict";
    init_src();
    Error31 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts
var finishUpdateGuideData_exports = {};
__export(finishUpdateGuideData_exports, {
  Error: () => Error32
});
var Error32;
var init_finishUpdateGuideData = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts"() {
    "use strict";
    init_src();
    Error32 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/createGuide.ts
var createGuide_exports = {};
__export(createGuide_exports, {
  Error: () => Error33
});
var Error33;
var init_createGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/createGuide.ts"() {
    "use strict";
    init_src();
    Error33 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts
var createEmptyTextGuide_exports = {};
__export(createEmptyTextGuide_exports, {
  Error: () => Error34
});
var Error34;
var init_createEmptyTextGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts"() {
    "use strict";
    init_src();
    Error34 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/updateGuidePreview.ts
var updateGuidePreview_exports = {};
__export(updateGuidePreview_exports, {
  Error: () => Error35
});
var Error35;
var init_updateGuidePreview = __esm({
  "src/api/resources/guides/resources/guideMutations/client/updateGuidePreview.ts"() {
    "use strict";
    init_src();
    Error35 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.updateGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/pinGuide.ts
var pinGuide_exports = {};
__export(pinGuide_exports, {
  Error: () => Error36
});
var Error36;
var init_pinGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/pinGuide.ts"() {
    "use strict";
    init_src();
    Error36 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.pinGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/deleteGuide.ts
var deleteGuide_exports = {};
__export(deleteGuide_exports, {
  Error: () => Error37
});
var Error37;
var init_deleteGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/deleteGuide.ts"() {
    "use strict";
    init_src();
    Error37 = {
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.deleteGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/moveGuide.ts
var moveGuide_exports = {};
__export(moveGuide_exports, {
  Error: () => Error38
});
var Error38;
var init_moveGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/moveGuide.ts"() {
    "use strict";
    init_src();
    Error38 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.moveGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/reorderGuide.ts
var reorderGuide_exports = {};
__export(reorderGuide_exports, {
  Error: () => Error39
});
var Error39;
var init_reorderGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/reorderGuide.ts"() {
    "use strict";
    init_src();
    Error39 = {
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.reorderGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/exportGuide.ts
var exportGuide_exports = {};
__export(exportGuide_exports, {
  Error: () => Error40
});
var Error40;
var init_exportGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/exportGuide.ts"() {
    "use strict";
    init_src();
    Error40 = {
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.exportGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/convertToGif.ts
var convertToGif_exports = {};
__export(convertToGif_exports, {
  Error: () => Error41
});
var Error41;
var init_convertToGif = __esm({
  "src/api/resources/guides/resources/guideMutations/client/convertToGif.ts"() {
    "use strict";
    init_src();
    Error41 = {
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.convertToGif.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/finishUploadVideoGuide.ts
var finishUploadVideoGuide_exports = {};
__export(finishUploadVideoGuide_exports, {
  Error: () => Error42
});
var Error42;
var init_finishUploadVideoGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/finishUploadVideoGuide.ts"() {
    "use strict";
    init_src();
    Error42 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadVideoGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.finishUploadVideoGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/duplicateGuide.ts
var duplicateGuide_exports = {};
__export(duplicateGuide_exports, {
  Error: () => Error43
});
var Error43;
var init_duplicateGuide = __esm({
  "src/api/resources/guides/resources/guideMutations/client/duplicateGuide.ts"() {
    "use strict";
    init_src();
    Error43 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideMutations.duplicateGuide.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/index.ts
var init_client6 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/index.ts"() {
    "use strict";
    init_requests3();
    init_generateVideo();
    init_generateEditedVideo();
    init_generateBookendsVideo();
    init_enhance();
    init_enhanceVideoTranscript();
    init_getLoomToken();
    init_startCreateGuide();
    init_finishCreateGuide();
    init_initiateCreateGuide();
    init_initiateCreateVideoGuide();
    init_uploadImage();
    init_uploadVideoChunk();
    init_compileVideo();
    init_updateGuideData();
    init_updateVideoEdits();
    init_finishUpdateGuideData();
    init_createGuide();
    init_createEmptyTextGuide();
    init_updateGuidePreview();
    init_pinGuide();
    init_deleteGuide();
    init_moveGuide();
    init_reorderGuide();
    init_exportGuide();
    init_convertToGif();
    init_finishUploadVideoGuide();
    init_duplicateGuide();
  }
});

// src/api/resources/guides/resources/guideMutations/index.ts
var guideMutations_exports = {};
__export(guideMutations_exports, {
  compileVideo: () => compileVideo_exports,
  convertToGif: () => convertToGif_exports,
  createEmptyTextGuide: () => createEmptyTextGuide_exports,
  createGuide: () => createGuide_exports,
  deleteGuide: () => deleteGuide_exports,
  duplicateGuide: () => duplicateGuide_exports,
  enhance: () => enhance_exports,
  enhanceVideoTranscript: () => enhanceVideoTranscript_exports,
  exportGuide: () => exportGuide_exports,
  finishCreateGuide: () => finishCreateGuide_exports,
  finishUpdateGuideData: () => finishUpdateGuideData_exports,
  finishUploadVideoGuide: () => finishUploadVideoGuide_exports,
  generateBookendsVideo: () => generateBookendsVideo_exports,
  generateEditedVideo: () => generateEditedVideo_exports,
  generateVideo: () => generateVideo_exports,
  getLoomToken: () => getLoomToken_exports,
  initiateCreateGuide: () => initiateCreateGuide_exports,
  initiateCreateVideoGuide: () => initiateCreateVideoGuide_exports,
  moveGuide: () => moveGuide_exports,
  pinGuide: () => pinGuide_exports,
  reorderGuide: () => reorderGuide_exports,
  startCreateGuide: () => startCreateGuide_exports,
  updateGuideData: () => updateGuideData_exports,
  updateGuidePreview: () => updateGuidePreview_exports,
  updateVideoEdits: () => updateVideoEdits_exports,
  uploadImage: () => uploadImage_exports,
  uploadVideoChunk: () => uploadVideoChunk_exports
});
var init_guideMutations = __esm({
  "src/api/resources/guides/resources/guideMutations/index.ts"() {
    "use strict";
    init_types6();
    init_client6();
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoObject.ts
var init_VideoObject = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoObject.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoRecordingType.ts
var VideoRecordingType;
var init_VideoRecordingType = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoRecordingType.ts"() {
    "use strict";
    VideoRecordingType = {
      Default: "default",
      Loom: "loom"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/PublishedVideoType.ts
var PublishedVideoType;
var init_PublishedVideoType = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PublishedVideoType.ts"() {
    "use strict";
    PublishedVideoType = {
      Ai: "ai",
      Original: "original",
      None: "none"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoMetadata.ts
var init_VideoMetadata = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoMetadata.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts
var init_PresignedUrlsForGuide = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts
var init_PresignedUrlsResponse = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Guide.ts
var init_Guide = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Guide.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideHeader.ts
var init_GuideHeader = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideHeader.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuidePreview.ts
var init_GuidePreview = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuidePreview.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GuideData.ts
var init_GuideData = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GuideData.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/PlainDoc.ts
var init_PlainDoc = __esm({
  "src/api/resources/guides/resources/guideTypes/types/PlainDoc.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/DocStep.ts
var init_DocStep = __esm({
  "src/api/resources/guides/resources/guideTypes/types/DocStep.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Coordinates.ts
var init_Coordinates = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Coordinates.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/AutoProgressable.ts
var AutoProgressable;
var init_AutoProgressable = __esm({
  "src/api/resources/guides/resources/guideTypes/types/AutoProgressable.ts"() {
    "use strict";
    AutoProgressable = {
      Auto: "auto",
      NewButton: "newButton"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/TourStep.ts
var init_TourStep = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TourStep.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/TourStepMetadata.ts
var init_TourStepMetadata = __esm({
  "src/api/resources/guides/resources/guideTypes/types/TourStepMetadata.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/CustomSelector.ts
var init_CustomSelector = __esm({
  "src/api/resources/guides/resources/guideTypes/types/CustomSelector.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/DomElementData.ts
var init_DomElementData = __esm({
  "src/api/resources/guides/resources/guideTypes/types/DomElementData.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/GeneratedVideo.ts
var init_GeneratedVideo = __esm({
  "src/api/resources/guides/resources/guideTypes/types/GeneratedVideo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/EditedVideo.ts
var init_EditedVideo = __esm({
  "src/api/resources/guides/resources/guideTypes/types/EditedVideo.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VideoClip.ts
var init_VideoClip = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VideoClip.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/Voice.ts
var init_Voice = __esm({
  "src/api/resources/guides/resources/guideTypes/types/Voice.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideTypes/types/VoiceEngine.ts
var VoiceEngine;
var init_VoiceEngine = __esm({
  "src/api/resources/guides/resources/guideTypes/types/VoiceEngine.ts"() {
    "use strict";
    VoiceEngine = {
      Google: "google",
      Play: "play"
    };
  }
});

// src/api/resources/guides/resources/guideTypes/types/index.ts
var init_types7 = __esm({
  "src/api/resources/guides/resources/guideTypes/types/index.ts"() {
    "use strict";
    init_VideoObject();
    init_VideoRecordingType();
    init_PublishedVideoType();
    init_VideoMetadata();
    init_PresignedUrlsForGuide();
    init_PresignedUrlsResponse();
    init_Guide();
    init_GuideHeader();
    init_GuidePreview();
    init_GuideData();
    init_PlainDoc();
    init_DocStep();
    init_Coordinates();
    init_AutoProgressable();
    init_TourStep();
    init_TourStepMetadata();
    init_CustomSelector();
    init_DomElementData();
    init_GeneratedVideo();
    init_EditedVideo();
    init_VideoClip();
    init_Voice();
    init_VoiceEngine();
  }
});

// src/api/resources/guides/resources/guideTypes/index.ts
var guideTypes_exports = {};
__export(guideTypes_exports, {
  AutoProgressable: () => AutoProgressable,
  PublishedVideoType: () => PublishedVideoType,
  VideoRecordingType: () => VideoRecordingType,
  VoiceEngine: () => VoiceEngine
});
var init_guideTypes = __esm({
  "src/api/resources/guides/resources/guideTypes/index.ts"() {
    "use strict";
    init_types7();
  }
});

// src/api/resources/guides/resources/guideQueries/client/requests/index.ts
var init_requests4 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/resources/guideQueries/client/search.ts
var search_exports = {};
__export(search_exports, {
  Error: () => Error44
});
var Error44;
var init_search = __esm({
  "src/api/resources/guides/resources/guideQueries/client/search.ts"() {
    "use strict";
    init_src();
    Error44 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports = {};
__export(getGuidePreviews_exports, {
  Error: () => Error45
});
var Error45;
var init_getGuidePreviews = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error45 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports = {};
__export(getAllGuidePreviews_exports, {
  Error: () => Error46
});
var Error46;
var init_getAllGuidePreviews = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error46 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuideData.ts
var getGuideData_exports = {};
__export(getGuideData_exports, {
  Error: () => Error47
});
var Error47;
var init_getGuideData = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    Error47 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getVideoEdits.ts
var getVideoEdits_exports = {};
__export(getVideoEdits_exports, {
  Error: () => Error48
});
var Error48;
var init_getVideoEdits = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getVideoEdits.ts"() {
    "use strict";
    init_src();
    Error48 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/getGuidePreview.ts
var getGuidePreview_exports = {};
__export(getGuidePreview_exports, {
  Error: () => Error49
});
var Error49;
var init_getGuidePreview = __esm({
  "src/api/resources/guides/resources/guideQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    Error49 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.guides.guideQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/index.ts
var init_client7 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/index.ts"() {
    "use strict";
    init_requests4();
    init_search();
    init_getGuidePreviews();
    init_getAllGuidePreviews();
    init_getGuideData();
    init_getVideoEdits();
    init_getGuidePreview();
  }
});

// src/api/resources/guides/resources/guideQueries/index.ts
var guideQueries_exports = {};
__export(guideQueries_exports, {
  getAllGuidePreviews: () => getAllGuidePreviews_exports,
  getGuideData: () => getGuideData_exports,
  getGuidePreview: () => getGuidePreview_exports,
  getGuidePreviews: () => getGuidePreviews_exports,
  getVideoEdits: () => getVideoEdits_exports,
  search: () => search_exports
});
var init_guideQueries = __esm({
  "src/api/resources/guides/resources/guideQueries/index.ts"() {
    "use strict";
    init_client7();
  }
});

// src/api/resources/guides/resources/index.ts
var init_resources2 = __esm({
  "src/api/resources/guides/resources/index.ts"() {
    "use strict";
    init_guideMutations();
    init_types6();
    init_guideTypes();
    init_types7();
    init_guideQueries();
    init_requests3();
    init_requests4();
  }
});

// src/api/resources/guides/client/index.ts
var init_client8 = __esm({
  "src/api/resources/guides/client/index.ts"() {
    "use strict";
  }
});

// src/api/resources/guides/index.ts
var guides_exports = {};
__export(guides_exports, {
  AutoProgressable: () => AutoProgressable,
  PublishedVideoType: () => PublishedVideoType,
  VideoRecordingType: () => VideoRecordingType,
  VoiceEngine: () => VoiceEngine,
  guideMutations: () => guideMutations_exports,
  guideQueries: () => guideQueries_exports,
  guideTypes: () => guideTypes_exports
});
var init_guides = __esm({
  "src/api/resources/guides/index.ts"() {
    "use strict";
    init_resources2();
    init_client8();
  }
});

// src/api/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts
var init_InvalidSessionErrorBody = __esm({
  "src/api/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenterQueries/types/index.ts
var init_types8 = __esm({
  "src/api/resources/helpcenterQueries/types/index.ts"() {
    "use strict";
    init_InvalidSessionErrorBody();
  }
});

// src/api/resources/helpcenterQueries/client/requests/index.ts
var init_requests5 = __esm({
  "src/api/resources/helpcenterQueries/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/helpcenterQueries/client/validateToken.ts
var validateToken_exports = {};
__export(validateToken_exports, {
  Error: () => Error50
});
var Error50;
var init_validateToken = __esm({
  "src/api/resources/helpcenterQueries/client/validateToken.ts"() {
    "use strict";
    init_src();
    Error50 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.validateToken.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getOrganization.ts
var getOrganization_exports = {};
__export(getOrganization_exports, {
  Error: () => Error51
});
var Error51;
var init_getOrganization = __esm({
  "src/api/resources/helpcenterQueries/client/getOrganization.ts"() {
    "use strict";
    init_src();
    Error51 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/search.ts
var search_exports2 = {};
__export(search_exports2, {
  Error: () => Error52
});
var Error52;
var init_search2 = __esm({
  "src/api/resources/helpcenterQueries/client/search.ts"() {
    "use strict";
    init_src();
    Error52 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.search.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports2 = {};
__export(getGuidePreviews_exports2, {
  Error: () => Error53
});
var Error53;
var init_getGuidePreviews2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error53 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports2 = {};
__export(getAllGuidePreviews_exports2, {
  Error: () => Error54
});
var Error54;
var init_getAllGuidePreviews2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    Error54 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuideData.ts
var getGuideData_exports2 = {};
__export(getGuideData_exports2, {
  Error: () => Error55
});
var Error55;
var init_getGuideData2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    Error55 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuideData.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getGuidePreview.ts
var getGuidePreview_exports2 = {};
__export(getGuidePreview_exports2, {
  Error: () => Error56
});
var Error56;
var init_getGuidePreview2 = __esm({
  "src/api/resources/helpcenterQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    Error56 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getGuidePreview.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getVideoEdits.ts
var getVideoEdits_exports2 = {};
__export(getVideoEdits_exports2, {
  Error: () => Error57
});
var Error57;
var init_getVideoEdits2 = __esm({
  "src/api/resources/helpcenterQueries/client/getVideoEdits.ts"() {
    "use strict";
    init_src();
    Error57 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      queryFailedError: () => {
        return {
          error: "QueryFailedError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getVideoEdits.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          case "QueryFailedError":
            return visitor.queryFailedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getCollections.ts
var getCollections_exports2 = {};
__export(getCollections_exports2, {
  Error: () => Error58
});
var Error58;
var init_getCollections2 = __esm({
  "src/api/resources/helpcenterQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    Error58 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllChildren.ts
var getAllChildren_exports2 = {};
__export(getAllChildren_exports2, {
  Error: () => Error59
});
var Error59;
var init_getAllChildren2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    Error59 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllChildren.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getAllCollections.ts
var getAllCollections_exports2 = {};
__export(getAllCollections_exports2, {
  Error: () => Error60
});
var Error60;
var init_getAllCollections2 = __esm({
  "src/api/resources/helpcenterQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    Error60 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getAllCollections.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/getPath.ts
var getPath_exports2 = {};
__export(getPath_exports2, {
  Error: () => Error61
});
var Error61;
var init_getPath2 = __esm({
  "src/api/resources/helpcenterQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    Error61 = {
      invalidSessionError: (value) => {
        return {
          content: value,
          error: "InvalidSessionError",
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.helpcenterQueries.getPath.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "InvalidSessionError":
            return visitor.invalidSessionError(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/index.ts
var init_client9 = __esm({
  "src/api/resources/helpcenterQueries/client/index.ts"() {
    "use strict";
    init_requests5();
    init_validateToken();
    init_getOrganization();
    init_search2();
    init_getGuidePreviews2();
    init_getAllGuidePreviews2();
    init_getGuideData2();
    init_getGuidePreview2();
    init_getVideoEdits2();
    init_getCollections2();
    init_getAllChildren2();
    init_getAllCollections2();
    init_getPath2();
  }
});

// src/api/resources/helpcenterQueries/index.ts
var helpcenterQueries_exports = {};
__export(helpcenterQueries_exports, {
  getAllChildren: () => getAllChildren_exports2,
  getAllCollections: () => getAllCollections_exports2,
  getAllGuidePreviews: () => getAllGuidePreviews_exports2,
  getCollections: () => getCollections_exports2,
  getGuideData: () => getGuideData_exports2,
  getGuidePreview: () => getGuidePreview_exports2,
  getGuidePreviews: () => getGuidePreviews_exports2,
  getOrganization: () => getOrganization_exports,
  getPath: () => getPath_exports2,
  getVideoEdits: () => getVideoEdits_exports2,
  search: () => search_exports2,
  validateToken: () => validateToken_exports
});
var init_helpcenterQueries = __esm({
  "src/api/resources/helpcenterQueries/index.ts"() {
    "use strict";
    init_types8();
    init_client9();
  }
});

// src/api/resources/organization/types/User.ts
var init_User = __esm({
  "src/api/resources/organization/types/User.ts"() {
    "use strict";
  }
});

// src/api/resources/organization/types/OrganizationInput.ts
var init_OrganizationInput = __esm({
  "src/api/resources/organization/types/OrganizationInput.ts"() {
    "use strict";
  }
});

// src/api/resources/organization/types/Organization.ts
var init_Organization = __esm({
  "src/api/resources/organization/types/Organization.ts"() {
    "use strict";
  }
});

// src/api/resources/organization/types/GetAllOrganizationsResponse.ts
var init_GetAllOrganizationsResponse = __esm({
  "src/api/resources/organization/types/GetAllOrganizationsResponse.ts"() {
    "use strict";
  }
});

// src/api/resources/organization/types/index.ts
var init_types9 = __esm({
  "src/api/resources/organization/types/index.ts"() {
    "use strict";
    init_User();
    init_OrganizationInput();
    init_Organization();
    init_GetAllOrganizationsResponse();
  }
});

// src/api/resources/organization/client/requests/index.ts
var init_requests6 = __esm({
  "src/api/resources/organization/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/organization/client/getOrganization.ts
var getOrganization_exports2 = {};
__export(getOrganization_exports2, {
  Error: () => Error62
});
var Error62;
var init_getOrganization2 = __esm({
  "src/api/resources/organization/client/getOrganization.ts"() {
    "use strict";
    init_src();
    Error62 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organization.getOrganization.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organization/client/getHostname.ts
var getHostname_exports = {};
__export(getHostname_exports, {
  Error: () => Error63
});
var Error63;
var init_getHostname = __esm({
  "src/api/resources/organization/client/getHostname.ts"() {
    "use strict";
    init_src();
    Error63 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organization.getHostname.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organization/client/getOrganizationFromId.ts
var getOrganizationFromId_exports = {};
__export(getOrganizationFromId_exports, {
  Error: () => Error64
});
var Error64;
var init_getOrganizationFromId = __esm({
  "src/api/resources/organization/client/getOrganizationFromId.ts"() {
    "use strict";
    init_src();
    Error64 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organization.getOrganizationFromId.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organization/client/getHostnameFromId.ts
var getHostnameFromId_exports = {};
__export(getHostnameFromId_exports, {
  Error: () => Error65
});
var Error65;
var init_getHostnameFromId = __esm({
  "src/api/resources/organization/client/getHostnameFromId.ts"() {
    "use strict";
    init_src();
    Error65 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organization.getHostnameFromId.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organization/client/getOrganizationFromHostName.ts
var getOrganizationFromHostName_exports = {};
__export(getOrganizationFromHostName_exports, {
  Error: () => Error66
});
var Error66;
var init_getOrganizationFromHostName = __esm({
  "src/api/resources/organization/client/getOrganizationFromHostName.ts"() {
    "use strict";
    init_src();
    Error66 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.organization.getOrganizationFromHostName.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.organization.getOrganizationFromHostName.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/organization/client/index.ts
var init_client10 = __esm({
  "src/api/resources/organization/client/index.ts"() {
    "use strict";
    init_requests6();
    init_getOrganization2();
    init_getHostname();
    init_getOrganizationFromId();
    init_getHostnameFromId();
    init_getOrganizationFromHostName();
  }
});

// src/api/resources/organization/index.ts
var organization_exports = {};
__export(organization_exports, {
  getHostname: () => getHostname_exports,
  getHostnameFromId: () => getHostnameFromId_exports,
  getOrganization: () => getOrganization_exports2,
  getOrganizationFromHostName: () => getOrganizationFromHostName_exports,
  getOrganizationFromId: () => getOrganizationFromId_exports
});
var init_organization = __esm({
  "src/api/resources/organization/index.ts"() {
    "use strict";
    init_types9();
    init_client10();
  }
});

// src/api/resources/video/resources/videoEdits/types/Version.ts
var Version;
var init_Version = __esm({
  "src/api/resources/video/resources/videoEdits/types/Version.ts"() {
    "use strict";
    Version = {
      Oct162023: "oct162023"
    };
  }
});

// src/api/resources/video/resources/videoEdits/types/ZoomEdit.ts
var init_ZoomEdit = __esm({
  "src/api/resources/video/resources/videoEdits/types/ZoomEdit.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/Cover.ts
var init_Cover = __esm({
  "src/api/resources/video/resources/videoEdits/types/Cover.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/Background.ts
var init_Background = __esm({
  "src/api/resources/video/resources/videoEdits/types/Background.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/VideoEdits.ts
var init_VideoEdits = __esm({
  "src/api/resources/video/resources/videoEdits/types/VideoEdits.ts"() {
    "use strict";
  }
});

// src/api/resources/video/resources/videoEdits/types/index.ts
var init_types10 = __esm({
  "src/api/resources/video/resources/videoEdits/types/index.ts"() {
    "use strict";
    init_Version();
    init_ZoomEdit();
    init_Cover();
    init_Background();
    init_VideoEdits();
  }
});

// src/api/resources/video/resources/videoEdits/index.ts
var videoEdits_exports = {};
__export(videoEdits_exports, {
  Version: () => Version
});
var init_videoEdits = __esm({
  "src/api/resources/video/resources/videoEdits/index.ts"() {
    "use strict";
    init_types10();
  }
});

// src/api/resources/video/resources/index.ts
var init_resources3 = __esm({
  "src/api/resources/video/resources/index.ts"() {
    "use strict";
    init_videoEdits();
    init_types10();
  }
});

// src/api/resources/video/index.ts
var video_exports = {};
__export(video_exports, {
  Version: () => Version,
  videoEdits: () => videoEdits_exports
});
var init_video = __esm({
  "src/api/resources/video/index.ts"() {
    "use strict";
    init_resources3();
  }
});

// src/api/resources/externalAuth/client/requests/index.ts
var init_requests7 = __esm({
  "src/api/resources/externalAuth/client/requests/index.ts"() {
    "use strict";
  }
});

// src/api/resources/externalAuth/client/createToken.ts
var createToken_exports = {};
__export(createToken_exports, {
  Error: () => Error67
});
var Error67;
var init_createToken = __esm({
  "src/api/resources/externalAuth/client/createToken.ts"() {
    "use strict";
    init_src();
    Error67 = {
      unauthorizedError: () => {
        return {
          error: "UnauthorizedError",
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.externalAuth.createToken.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnauthorizedError":
            return visitor.unauthorizedError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/externalAuth/client/index.ts
var init_client11 = __esm({
  "src/api/resources/externalAuth/client/index.ts"() {
    "use strict";
    init_requests7();
    init_createToken();
  }
});

// src/api/resources/externalAuth/index.ts
var externalAuth_exports = {};
__export(externalAuth_exports, {
  createToken: () => createToken_exports
});
var init_externalAuth = __esm({
  "src/api/resources/externalAuth/index.ts"() {
    "use strict";
    init_client11();
  }
});

// src/api/resources/healthcheck/client/healthcheck.ts
var healthcheck_exports = {};
__export(healthcheck_exports, {
  Error: () => Error68
});
var Error68;
var init_healthcheck = __esm({
  "src/api/resources/healthcheck/client/healthcheck.ts"() {
    "use strict";
    init_src();
    Error68 = {
      unavailabilityError: () => {
        return {
          error: "UnavailabilityError",
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      _unknown: (fetcherError) => {
        return {
          error: void 0,
          content: fetcherError,
          _visit: function(visitor) {
            return api_exports.healthcheck.healthcheck.Error._visit(this, visitor);
          }
        };
      },
      _visit: (value, visitor) => {
        switch (value.error) {
          case "UnavailabilityError":
            return visitor.unavailabilityError();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/api/resources/healthcheck/client/index.ts
var init_client12 = __esm({
  "src/api/resources/healthcheck/client/index.ts"() {
    "use strict";
    init_healthcheck();
  }
});

// src/api/resources/healthcheck/index.ts
var healthcheck_exports2 = {};
__export(healthcheck_exports2, {
  healthcheck: () => healthcheck_exports
});
var init_healthcheck2 = __esm({
  "src/api/resources/healthcheck/index.ts"() {
    "use strict";
    init_client12();
  }
});

// src/api/resources/index.ts
var init_resources4 = __esm({
  "src/api/resources/index.ts"() {
    "use strict";
    init_analytics();
    init_types();
    init_audio();
    init_types2();
    init_baseTypes();
    init_types3();
    init_collections();
    init_guides();
    init_helpcenterQueries();
    init_types8();
    init_organization();
    init_types9();
    init_video();
    init_externalAuth();
    init_healthcheck2();
    init_requests();
    init_requests7();
    init_requests5();
    init_requests6();
  }
});

// src/api/index.ts
var api_exports = {};
__export(api_exports, {
  Id: () => Id,
  analytics: () => analytics_exports,
  audio: () => audio_exports,
  baseTypes: () => baseTypes_exports,
  collections: () => collections_exports,
  externalAuth: () => externalAuth_exports,
  guides: () => guides_exports,
  healthcheck: () => healthcheck_exports2,
  helpcenterQueries: () => helpcenterQueries_exports,
  organization: () => organization_exports,
  video: () => video_exports
});
var init_api = __esm({
  "src/api/index.ts"() {
    "use strict";
    init_resources4();
  }
});

// src/core/schemas/Schema.ts
var SchemaType;
var init_Schema = __esm({
  "src/core/schemas/Schema.ts"() {
    "use strict";
    SchemaType = {
      DATE: "date",
      ENUM: "enum",
      LIST: "list",
      STRING_LITERAL: "stringLiteral",
      OBJECT: "object",
      ANY: "any",
      BOOLEAN: "boolean",
      NUMBER: "number",
      STRING: "string",
      UNKNOWN: "unknown",
      RECORD: "record",
      SET: "set",
      UNION: "union",
      OPTIONAL: "optional"
    };
  }
});

// src/core/schemas/builders/schema-utils/stringifyValidationErrors.ts
function stringifyValidationError(error) {
  if (error.path.length === 0) {
    return error.message;
  }
  return `${error.path.join(" -> ")}: ${error.message}`;
}
var init_stringifyValidationErrors = __esm({
  "src/core/schemas/builders/schema-utils/stringifyValidationErrors.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/schema-utils/JsonError.ts
var JsonError;
var init_JsonError = __esm({
  "src/core/schemas/builders/schema-utils/JsonError.ts"() {
    "use strict";
    init_stringifyValidationErrors();
    JsonError = class extends Error {
      constructor(errors) {
        super(errors.map(stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, JsonError.prototype);
      }
    };
  }
});

// src/core/schemas/builders/schema-utils/ParseError.ts
var ParseError;
var init_ParseError = __esm({
  "src/core/schemas/builders/schema-utils/ParseError.ts"() {
    "use strict";
    init_stringifyValidationErrors();
    ParseError = class extends Error {
      constructor(errors) {
        super(errors.map(stringifyValidationError).join("; "));
        this.errors = errors;
        Object.setPrototypeOf(this, ParseError.prototype);
      }
    };
  }
});

// src/core/schemas/builders/schema-utils/getSchemaUtils.ts
function getSchemaUtils(schema) {
  return {
    optional: () => optional(schema),
    transform: (transformer) => transform(schema, transformer),
    parseOrThrow: async (raw, opts) => {
      const parsed = await schema.parse(raw, opts);
      if (parsed.ok) {
        return parsed.value;
      }
      throw new ParseError(parsed.errors);
    },
    jsonOrThrow: async (parsed, opts) => {
      const raw = await schema.json(parsed, opts);
      if (raw.ok) {
        return raw.value;
      }
      throw new JsonError(raw.errors);
    }
  };
}
function optional(schema) {
  const baseSchema = {
    parse: (raw, opts) => {
      if (raw == null) {
        return {
          ok: true,
          value: void 0
        };
      }
      return schema.parse(raw, opts);
    },
    json: (parsed, opts) => {
      if (parsed == null) {
        return {
          ok: true,
          value: null
        };
      }
      return schema.json(parsed, opts);
    },
    getType: () => SchemaType.OPTIONAL
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function transform(schema, transformer) {
  const baseSchema = {
    parse: async (raw, opts) => {
      const parsed = await schema.parse(raw, opts);
      if (!parsed.ok) {
        return parsed;
      }
      return {
        ok: true,
        value: transformer.transform(parsed.value)
      };
    },
    json: async (transformed, opts) => {
      const parsed = await transformer.untransform(transformed);
      return schema.json(parsed, opts);
    },
    getType: () => schema.getType()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_getSchemaUtils = __esm({
  "src/core/schemas/builders/schema-utils/getSchemaUtils.ts"() {
    "use strict";
    init_Schema();
    init_JsonError();
    init_ParseError();
  }
});

// src/core/schemas/builders/schema-utils/index.ts
var init_schema_utils = __esm({
  "src/core/schemas/builders/schema-utils/index.ts"() {
    "use strict";
    init_getSchemaUtils();
    init_JsonError();
    init_ParseError();
  }
});

// src/core/schemas/builders/date/date.ts
function date() {
  const baseSchema = {
    parse: (raw) => {
      if (typeof raw === "string" && ISO_8601_REGEX.test(raw)) {
        return {
          ok: true,
          value: new Date(raw)
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not an ISO 8601 date string"
            }
          ]
        };
      }
    },
    json: (date2) => {
      if (date2 instanceof Date) {
        return {
          ok: true,
          value: date2.toISOString()
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a Date object"
            }
          ]
        };
      }
    },
    getType: () => SchemaType.DATE
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var ISO_8601_REGEX;
var init_date = __esm({
  "src/core/schemas/builders/date/date.ts"() {
    "use strict";
    init_Schema();
    init_schema_utils();
    ISO_8601_REGEX = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
  }
});

// src/core/schemas/builders/date/index.ts
var init_date2 = __esm({
  "src/core/schemas/builders/date/index.ts"() {
    "use strict";
    init_date();
  }
});

// src/core/schemas/utils/createIdentitySchemaCreator.ts
function createIdentitySchemaCreator(schemaType, validate) {
  return () => {
    const baseSchema = {
      parse: validate,
      json: validate,
      getType: () => schemaType
    };
    return {
      ...baseSchema,
      ...getSchemaUtils(baseSchema)
    };
  };
}
var init_createIdentitySchemaCreator = __esm({
  "src/core/schemas/utils/createIdentitySchemaCreator.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/enum/enum.ts
function enum_(values) {
  const validValues = new Set(values);
  const schemaCreator = createIdentitySchemaCreator(SchemaType.ENUM, (value, { allowUnknownKeys = false } = {}) => {
    if (typeof value === "string" && (validValues.has(value) || allowUnknownKeys)) {
      return {
        ok: true,
        value
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [],
            message: "Not one of the allowed values"
          }
        ]
      };
    }
  });
  return schemaCreator();
}
var init_enum = __esm({
  "src/core/schemas/builders/enum/enum.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/enum/index.ts
var init_enum2 = __esm({
  "src/core/schemas/builders/enum/index.ts"() {
    "use strict";
    init_enum();
  }
});

// src/core/schemas/builders/lazy/lazy.ts
function lazy(getter) {
  const baseSchema = constructLazyBaseSchema(getter);
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function constructLazyBaseSchema(getter) {
  return {
    parse: async (raw, opts) => (await getMemoizedSchema(getter)).parse(raw, opts),
    json: async (parsed, opts) => (await getMemoizedSchema(getter)).json(parsed, opts),
    getType: async () => (await getMemoizedSchema(getter)).getType()
  };
}
async function getMemoizedSchema(getter) {
  const castedGetter = getter;
  if (castedGetter.__zurg_memoized == null) {
    castedGetter.__zurg_memoized = await getter();
  }
  return castedGetter.__zurg_memoized;
}
var init_lazy = __esm({
  "src/core/schemas/builders/lazy/lazy.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/utils/entries.ts
function entries(object2) {
  return Object.entries(object2);
}
var init_entries = __esm({
  "src/core/schemas/utils/entries.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/filterObject.ts
function filterObject(obj, keysToInclude) {
  const keysToIncludeSet = new Set(keysToInclude);
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (keysToIncludeSet.has(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
var init_filterObject = __esm({
  "src/core/schemas/utils/filterObject.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/isPlainObject.ts
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (Object.getPrototypeOf(value) === null) {
    return true;
  }
  let proto = value;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(value) === proto;
}
var NOT_AN_OBJECT_ERROR_MESSAGE;
var init_isPlainObject = __esm({
  "src/core/schemas/utils/isPlainObject.ts"() {
    "use strict";
    NOT_AN_OBJECT_ERROR_MESSAGE = "Not an object";
  }
});

// src/core/schemas/utils/keys.ts
function keys(object2) {
  return Object.keys(object2);
}
var init_keys = __esm({
  "src/core/schemas/utils/keys.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/partition.ts
function partition(items, predicate) {
  const trueItems = [], falseItems = [];
  for (const item of items) {
    if (predicate(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  }
  return [trueItems, falseItems];
}
var init_partition = __esm({
  "src/core/schemas/utils/partition.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object-like/getObjectLikeUtils.ts
function getObjectLikeUtils(schema) {
  return {
    withParsedProperties: (properties) => withParsedProperties(schema, properties)
  };
}
function withParsedProperties(objectLike, properties) {
  const objectSchema = {
    parse: async (raw, opts) => {
      const parsedObject = await objectLike.parse(raw, opts);
      if (!parsedObject.ok) {
        return parsedObject;
      }
      const additionalProperties = Object.entries(properties).reduce(
        (processed, [key, value]) => {
          return {
            ...processed,
            [key]: typeof value === "function" ? value(parsedObject.value) : value
          };
        },
        {}
      );
      return {
        ok: true,
        value: {
          ...parsedObject.value,
          ...additionalProperties
        }
      };
    },
    json: (parsed, opts) => {
      if (!isPlainObject(parsed)) {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: NOT_AN_OBJECT_ERROR_MESSAGE
            }
          ]
        };
      }
      const addedPropertyKeys = new Set(Object.keys(properties));
      const parsedWithoutAddedProperties = filterObject(
        parsed,
        Object.keys(parsed).filter((key) => !addedPropertyKeys.has(key))
      );
      return objectLike.json(parsedWithoutAddedProperties, opts);
    },
    getType: () => objectLike.getType()
  };
  return {
    ...objectSchema,
    ...getSchemaUtils(objectSchema),
    ...getObjectLikeUtils(objectSchema)
  };
}
var init_getObjectLikeUtils = __esm({
  "src/core/schemas/builders/object-like/getObjectLikeUtils.ts"() {
    "use strict";
    init_filterObject();
    init_isPlainObject();
    init_schema_utils();
  }
});

// src/core/schemas/builders/object-like/index.ts
var init_object_like = __esm({
  "src/core/schemas/builders/object-like/index.ts"() {
    "use strict";
    init_getObjectLikeUtils();
  }
});

// src/core/schemas/builders/object/property.ts
function property(rawKey, valueSchema) {
  return {
    rawKey,
    valueSchema,
    isProperty: true
  };
}
function isProperty(maybeProperty) {
  return maybeProperty.isProperty;
}
var init_property = __esm({
  "src/core/schemas/builders/object/property.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object/object.ts
function object(schemas) {
  const baseSchema = {
    _getRawProperties: () => Promise.resolve(
      Object.entries(schemas).map(
        ([parsedKey, propertySchema]) => isProperty(propertySchema) ? propertySchema.rawKey : parsedKey
      )
    ),
    _getParsedProperties: () => Promise.resolve(keys(schemas)),
    parse: async (raw, opts) => {
      const rawKeyToProperty = {};
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const rawKey = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.rawKey : parsedKey;
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        const property2 = {
          rawKey,
          parsedKey,
          valueSchema
        };
        rawKeyToProperty[rawKey] = property2;
        if (await isSchemaRequired(valueSchema)) {
          requiredKeys.push(rawKey);
        }
      }
      return validateAndTransformObject({
        value: raw,
        requiredKeys,
        getProperty: (rawKey) => {
          const property2 = rawKeyToProperty[rawKey];
          if (property2 == null) {
            return void 0;
          }
          return {
            transformedKey: property2.parsedKey,
            transform: (propertyValue) => property2.valueSchema.parse(propertyValue, opts)
          };
        },
        allowUnknownKeys: opts?.allowUnknownKeys ?? false
      });
    },
    json: async (parsed, opts) => {
      const requiredKeys = [];
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const valueSchema = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty;
        if (await isSchemaRequired(valueSchema)) {
          requiredKeys.push(parsedKey);
        }
      }
      return validateAndTransformObject({
        value: parsed,
        requiredKeys,
        getProperty: (parsedKey) => {
          const property2 = schemas[parsedKey];
          if (property2 == null) {
            return void 0;
          }
          if (isProperty(property2)) {
            return {
              transformedKey: property2.rawKey,
              transform: (propertyValue) => property2.valueSchema.json(propertyValue, opts)
            };
          } else {
            return {
              transformedKey: parsedKey,
              transform: (propertyValue) => property2.json(propertyValue, opts)
            };
          }
        },
        allowUnknownKeys: opts?.allowUnknownKeys ?? false
      });
    },
    getType: () => SchemaType.OBJECT
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
async function validateAndTransformObject({
  value,
  requiredKeys,
  getProperty,
  allowUnknownKeys
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  const missingRequiredKeys = new Set(requiredKeys);
  const errors = [];
  const transformed = {};
  for (const [preTransformedKey, preTransformedItemValue] of Object.entries(value)) {
    const property2 = getProperty(preTransformedKey);
    if (property2 != null) {
      missingRequiredKeys.delete(preTransformedKey);
      const value2 = await property2.transform(preTransformedItemValue);
      if (value2.ok) {
        transformed[property2.transformedKey] = value2.value;
      } else {
        errors.push(
          ...value2.errors.map((error) => ({
            path: [preTransformedKey, ...error.path],
            message: error.message
          }))
        );
      }
    } else if (allowUnknownKeys) {
      transformed[preTransformedKey] = preTransformedItemValue;
    } else {
      errors.push({
        path: [preTransformedKey],
        message: `Unrecognized key "${preTransformedKey}"`
      });
    }
  }
  errors.push(
    ...requiredKeys.filter((key) => missingRequiredKeys.has(key)).map((key) => ({
      path: [],
      message: `Missing required key "${key}"`
    }))
  );
  if (errors.length === 0) {
    return {
      ok: true,
      value: transformed
    };
  } else {
    return {
      ok: false,
      errors
    };
  }
}
function getObjectUtils(schema) {
  return {
    extend: (extension) => {
      const baseSchema = {
        _getParsedProperties: async () => [
          ...await schema._getParsedProperties(),
          ...await extension._getParsedProperties()
        ],
        _getRawProperties: async () => [
          ...await schema._getRawProperties(),
          ...await extension._getRawProperties()
        ],
        parse: async (raw, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: await extension._getRawProperties(),
            value: raw,
            transformBase: (rawBase) => schema.parse(rawBase, opts),
            transformExtension: (rawExtension) => extension.parse(rawExtension, opts)
          });
        },
        json: async (parsed, opts) => {
          return validateAndTransformExtendedObject({
            extensionKeys: await extension._getParsedProperties(),
            value: parsed,
            transformBase: (parsedBase) => schema.json(parsedBase, opts),
            transformExtension: (parsedExtension) => extension.json(parsedExtension, opts)
          });
        },
        getType: () => SchemaType.OBJECT
      };
      return {
        ...baseSchema,
        ...getSchemaUtils(baseSchema),
        ...getObjectLikeUtils(baseSchema),
        ...getObjectUtils(baseSchema)
      };
    }
  };
}
async function validateAndTransformExtendedObject({
  extensionKeys,
  value,
  transformBase,
  transformExtension
}) {
  const extensionPropertiesSet = new Set(extensionKeys);
  const [extensionProperties, baseProperties] = partition(
    keys(value),
    (key) => extensionPropertiesSet.has(key)
  );
  const transformedBase = await transformBase(filterObject(value, baseProperties));
  const transformedExtension = await transformExtension(filterObject(value, extensionProperties));
  if (transformedBase.ok && transformedExtension.ok) {
    return {
      ok: true,
      value: {
        ...transformedBase.value,
        ...transformedExtension.value
      }
    };
  } else {
    return {
      ok: false,
      errors: [
        ...transformedBase.ok ? [] : transformedBase.errors,
        ...transformedExtension.ok ? [] : transformedExtension.errors
      ]
    };
  }
}
async function isSchemaRequired(schema) {
  return !await isSchemaOptional(schema);
}
async function isSchemaOptional(schema) {
  switch (await schema.getType()) {
    case SchemaType.ANY:
    case SchemaType.UNKNOWN:
    case SchemaType.OPTIONAL:
      return true;
    default:
      return false;
  }
}
var init_object = __esm({
  "src/core/schemas/builders/object/object.ts"() {
    "use strict";
    init_Schema();
    init_entries();
    init_filterObject();
    init_isPlainObject();
    init_keys();
    init_partition();
    init_object_like();
    init_schema_utils();
    init_property();
  }
});

// src/core/schemas/builders/object/index.ts
var init_object2 = __esm({
  "src/core/schemas/builders/object/index.ts"() {
    "use strict";
    init_object();
    init_property();
  }
});

// src/core/schemas/builders/lazy/lazyObject.ts
function lazyObject(getter) {
  const baseSchema = {
    ...constructLazyBaseSchema(getter),
    _getRawProperties: async () => (await getMemoizedSchema(getter))._getRawProperties(),
    _getParsedProperties: async () => (await getMemoizedSchema(getter))._getParsedProperties()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
var init_lazyObject = __esm({
  "src/core/schemas/builders/lazy/lazyObject.ts"() {
    "use strict";
    init_object2();
    init_object_like();
    init_schema_utils();
    init_lazy();
  }
});

// src/core/schemas/builders/lazy/index.ts
var init_lazy2 = __esm({
  "src/core/schemas/builders/lazy/index.ts"() {
    "use strict";
    init_lazy();
    init_lazyObject();
  }
});

// src/core/schemas/builders/list/list.ts
function list(schema) {
  const baseSchema = {
    parse: async (raw, opts) => validateAndTransformArray(raw, (item) => schema.parse(item, opts)),
    json: (parsed, opts) => validateAndTransformArray(parsed, (item) => schema.json(item, opts)),
    getType: () => SchemaType.LIST
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
async function validateAndTransformArray(value, transformItem) {
  if (!Array.isArray(value)) {
    return {
      ok: false,
      errors: [
        {
          message: "Not a list",
          path: []
        }
      ]
    };
  }
  const maybeValidItems = await Promise.all(value.map((item) => transformItem(item)));
  return maybeValidItems.reduce(
    (acc, item, index) => {
      if (acc.ok && item.ok) {
        return {
          ok: true,
          value: [...acc.value, item.value]
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!item.ok) {
        errors.push(
          ...item.errors.map((error) => ({
            path: [`[${index}]`, ...error.path],
            message: error.message
          }))
        );
      }
      return {
        ok: false,
        errors
      };
    },
    { ok: true, value: [] }
  );
}
var init_list = __esm({
  "src/core/schemas/builders/list/list.ts"() {
    "use strict";
    init_Schema();
    init_schema_utils();
  }
});

// src/core/schemas/builders/list/index.ts
var init_list2 = __esm({
  "src/core/schemas/builders/list/index.ts"() {
    "use strict";
    init_list();
  }
});

// src/core/schemas/builders/literals/stringLiteral.ts
function stringLiteral(literal) {
  const schemaCreator = createIdentitySchemaCreator(SchemaType.STRING_LITERAL, (value) => {
    if (value === literal) {
      return {
        ok: true,
        value: literal
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [],
            message: `Not equal to "${literal}"`
          }
        ]
      };
    }
  });
  return schemaCreator();
}
var init_stringLiteral = __esm({
  "src/core/schemas/builders/literals/stringLiteral.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/literals/index.ts
var init_literals = __esm({
  "src/core/schemas/builders/literals/index.ts"() {
    "use strict";
    init_stringLiteral();
  }
});

// src/core/schemas/builders/primitives/any.ts
var any;
var init_any = __esm({
  "src/core/schemas/builders/primitives/any.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    any = createIdentitySchemaCreator(SchemaType.ANY, (value) => ({ ok: true, value }));
  }
});

// src/core/schemas/builders/primitives/boolean.ts
var boolean;
var init_boolean = __esm({
  "src/core/schemas/builders/primitives/boolean.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    boolean = createIdentitySchemaCreator(SchemaType.BOOLEAN, (value) => {
      if (typeof value === "boolean") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a boolean"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/number.ts
var number;
var init_number = __esm({
  "src/core/schemas/builders/primitives/number.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    number = createIdentitySchemaCreator(SchemaType.NUMBER, (value) => {
      if (typeof value === "number") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a number"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/string.ts
var string;
var init_string = __esm({
  "src/core/schemas/builders/primitives/string.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    string = createIdentitySchemaCreator(SchemaType.STRING, (value) => {
      if (typeof value === "string") {
        return {
          ok: true,
          value
        };
      } else {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a string"
            }
          ]
        };
      }
    });
  }
});

// src/core/schemas/builders/primitives/unknown.ts
var unknown;
var init_unknown = __esm({
  "src/core/schemas/builders/primitives/unknown.ts"() {
    "use strict";
    init_Schema();
    init_createIdentitySchemaCreator();
    unknown = createIdentitySchemaCreator(SchemaType.UNKNOWN, (value) => ({ ok: true, value }));
  }
});

// src/core/schemas/builders/primitives/index.ts
var init_primitives = __esm({
  "src/core/schemas/builders/primitives/index.ts"() {
    "use strict";
    init_any();
    init_boolean();
    init_number();
    init_string();
    init_unknown();
  }
});

// src/core/schemas/builders/record/record.ts
function record(keySchema, valueSchema) {
  const baseSchema = {
    parse: async (raw, opts) => {
      return validateAndTransformRecord({
        value: raw,
        isKeyNumeric: await keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.parse(key, opts),
        transformValue: (value) => valueSchema.parse(value, opts)
      });
    },
    json: async (parsed, opts) => {
      return validateAndTransformRecord({
        value: parsed,
        isKeyNumeric: await keySchema.getType() === SchemaType.NUMBER,
        transformKey: (key) => keySchema.json(key, opts),
        transformValue: (value) => valueSchema.json(value, opts)
      });
    },
    getType: () => SchemaType.RECORD
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
async function validateAndTransformRecord({
  value,
  isKeyNumeric,
  transformKey,
  transformValue
}) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  return entries(value).reduce(
    async (accPromise, [stringKey, value2]) => {
      if (value2 == null) {
        return accPromise;
      }
      const acc = await accPromise;
      let key = stringKey;
      if (isKeyNumeric) {
        const numberKey = stringKey.length > 0 ? Number(stringKey) : NaN;
        if (!isNaN(numberKey)) {
          key = numberKey;
        }
      }
      const transformedKey = await transformKey(key);
      const transformedValue = await transformValue(value2);
      if (acc.ok && transformedKey.ok && transformedValue.ok) {
        return {
          ok: true,
          value: {
            ...acc.value,
            [transformedKey.value]: transformedValue.value
          }
        };
      }
      const errors = [];
      if (!acc.ok) {
        errors.push(...acc.errors);
      }
      if (!transformedKey.ok) {
        errors.push(
          ...transformedKey.errors.map((error) => ({
            path: [`${key} (key)`, ...error.path],
            message: error.message
          }))
        );
      }
      if (!transformedValue.ok) {
        errors.push(
          ...transformedValue.errors.map((error) => ({
            path: [stringKey, ...error.path],
            message: error.message
          }))
        );
      }
      return {
        ok: false,
        errors
      };
    },
    Promise.resolve({ ok: true, value: {} })
  );
}
var init_record = __esm({
  "src/core/schemas/builders/record/record.ts"() {
    "use strict";
    init_Schema();
    init_entries();
    init_isPlainObject();
    init_schema_utils();
  }
});

// src/core/schemas/builders/record/index.ts
var init_record2 = __esm({
  "src/core/schemas/builders/record/index.ts"() {
    "use strict";
    init_record();
  }
});

// src/core/schemas/builders/set/set.ts
function set(schema) {
  const listSchema = list(schema);
  const baseSchema = {
    parse: async (raw, opts) => {
      const parsedList = await listSchema.parse(raw, opts);
      if (parsedList.ok) {
        return {
          ok: true,
          value: new Set(parsedList.value)
        };
      } else {
        return parsedList;
      }
    },
    json: async (parsed, opts) => {
      if (!(parsed instanceof Set)) {
        return {
          ok: false,
          errors: [
            {
              path: [],
              message: "Not a Set"
            }
          ]
        };
      }
      const jsonList = await listSchema.json([...parsed], opts);
      return jsonList;
    },
    getType: () => SchemaType.SET
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_set = __esm({
  "src/core/schemas/builders/set/set.ts"() {
    "use strict";
    init_Schema();
    init_list2();
    init_schema_utils();
  }
});

// src/core/schemas/builders/set/index.ts
var init_set2 = __esm({
  "src/core/schemas/builders/set/index.ts"() {
    "use strict";
    init_set();
  }
});

// src/core/schemas/builders/union/discriminant.ts
function discriminant(parsedDiscriminant, rawDiscriminant) {
  return {
    parsedDiscriminant,
    rawDiscriminant
  };
}
var init_discriminant = __esm({
  "src/core/schemas/builders/union/discriminant.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/union/union.ts
function union(discriminant2, union2) {
  const rawDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.rawDiscriminant;
  const parsedDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.parsedDiscriminant;
  const discriminantValueSchema = enum_(keys(union2));
  const baseSchema = {
    parse: async (raw, opts) => {
      return transformAndValidateUnion(
        raw,
        rawDiscriminant,
        parsedDiscriminant,
        (discriminantValue) => discriminantValueSchema.parse(discriminantValue, opts),
        (discriminantValue) => union2[discriminantValue],
        opts?.allowUnknownKeys ?? false,
        (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.parse(additionalProperties, opts)
      );
    },
    json: async (parsed, opts) => {
      return transformAndValidateUnion(
        parsed,
        parsedDiscriminant,
        rawDiscriminant,
        (discriminantValue) => discriminantValueSchema.json(discriminantValue, opts),
        (discriminantValue) => union2[discriminantValue],
        opts?.allowUnknownKeys ?? false,
        (additionalProperties, additionalPropertiesSchema) => additionalPropertiesSchema.json(additionalProperties, opts)
      );
    },
    getType: () => SchemaType.UNION
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema)
  };
}
async function transformAndValidateUnion(value, discriminant2, transformedDiscriminant, transformDiscriminantValue, getAdditionalPropertiesSchema, allowUnknownKeys, transformAdditionalProperties) {
  if (!isPlainObject(value)) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: NOT_AN_OBJECT_ERROR_MESSAGE
        }
      ]
    };
  }
  const { [discriminant2]: discriminantValue, ...additionalProperties } = value;
  if (discriminantValue == null) {
    return {
      ok: false,
      errors: [
        {
          path: [],
          message: `Missing discriminant ("${discriminant2}")`
        }
      ]
    };
  }
  const transformedDiscriminantValue = await transformDiscriminantValue(discriminantValue);
  if (!transformedDiscriminantValue.ok) {
    return {
      ok: false,
      errors: transformedDiscriminantValue.errors.map((error) => ({
        path: [discriminant2, ...error.path],
        message: error.message
      }))
    };
  }
  const additionalPropertiesSchema = getAdditionalPropertiesSchema(transformedDiscriminantValue.value);
  if (additionalPropertiesSchema == null) {
    if (allowUnknownKeys) {
      return {
        ok: true,
        value: {
          [transformedDiscriminant]: transformedDiscriminantValue.value,
          ...additionalProperties
        }
      };
    } else {
      return {
        ok: false,
        errors: [
          {
            path: [discriminant2],
            message: "Unrecognized discriminant value"
          }
        ]
      };
    }
  }
  const transformedAdditionalProperties = await transformAdditionalProperties(
    additionalProperties,
    additionalPropertiesSchema
  );
  if (!transformedAdditionalProperties.ok) {
    return transformedAdditionalProperties;
  }
  return {
    ok: true,
    value: {
      [transformedDiscriminant]: discriminantValue,
      ...transformedAdditionalProperties.value
    }
  };
}
var init_union = __esm({
  "src/core/schemas/builders/union/union.ts"() {
    "use strict";
    init_Schema();
    init_isPlainObject();
    init_keys();
    init_enum2();
    init_object_like();
    init_schema_utils();
  }
});

// src/core/schemas/builders/union/index.ts
var init_union2 = __esm({
  "src/core/schemas/builders/union/index.ts"() {
    "use strict";
    init_discriminant();
    init_union();
  }
});

// src/core/schemas/builders/index.ts
var init_builders = __esm({
  "src/core/schemas/builders/index.ts"() {
    "use strict";
    init_date2();
    init_enum2();
    init_lazy2();
    init_list2();
    init_literals();
    init_object2();
    init_object_like();
    init_primitives();
    init_record2();
    init_schema_utils();
    init_set2();
    init_union2();
  }
});

// src/core/schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  JsonError: () => JsonError,
  ParseError: () => ParseError,
  any: () => any,
  boolean: () => boolean,
  date: () => date,
  discriminant: () => discriminant,
  enum_: () => enum_,
  getObjectLikeUtils: () => getObjectLikeUtils,
  getObjectUtils: () => getObjectUtils,
  getSchemaUtils: () => getSchemaUtils,
  isProperty: () => isProperty,
  lazy: () => lazy,
  lazyObject: () => lazyObject,
  list: () => list,
  number: () => number,
  object: () => object,
  optional: () => optional,
  property: () => property,
  record: () => record,
  set: () => set,
  string: () => string,
  stringLiteral: () => stringLiteral,
  transform: () => transform,
  union: () => union,
  unknown: () => unknown,
  withParsedProperties: () => withParsedProperties
});
var init_schemas = __esm({
  "src/core/schemas/index.ts"() {
    "use strict";
    init_builders();
    init_Schema();
  }
});

// node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
  }
});

// node_modules/buffer/index.js
var require_buffer = __commonJS({
  "node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports.Buffer = Buffer2;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports.kMaxLength = K_MAX_LENGTH;
    Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer2.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer2.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length);
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function Buffer2(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe(arg);
      }
      return from(arg, encodingOrOffset, length);
    }
    Buffer2.poolSize = 8192;
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof value === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer2.from(valueOf, encodingOrOffset, length);
      }
      const b = fromObject(value);
      if (b)
        return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    Buffer2.from = function(value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length);
    };
    Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer2, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer2.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer2.allocUnsafe = function(size) {
      return allocUnsafe(size);
    };
    Buffer2.allocUnsafeSlow = function(size) {
      return allocUnsafe(size);
    };
    function fromString(string2, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length = byteLength(string2, encoding) | 0;
      let buf = createBuffer(length);
      const actual = buf.write(string2, encoding);
      if (actual !== length) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array) {
      const length = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length);
      for (let i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length === void 0) {
        buf = new Uint8Array(array);
      } else if (length === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length);
      }
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer2.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer2.alloc(+length);
    }
    Buffer2.isBuffer = function isBuffer(b) {
      return b != null && b._isBuffer === true && b !== Buffer2.prototype;
    };
    Buffer2.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array))
        a = Buffer2.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array))
        b = Buffer2.from(b, b.offset, b.byteLength);
      if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b)
        return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    Buffer2.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer2.concat = function concat(list2, length) {
      if (!Array.isArray(list2)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list2.length === 0) {
        return Buffer2.alloc(0);
      }
      let i;
      if (length === void 0) {
        length = 0;
        for (i = 0; i < list2.length; ++i) {
          length += list2[i].length;
        }
      }
      const buffer = Buffer2.allocUnsafe(length);
      let pos = 0;
      for (i = 0; i < list2.length; ++i) {
        let buf = list2[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer2.isBuffer(buf))
              buf = Buffer2.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer2.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string2, encoding) {
      if (Buffer2.isBuffer(string2)) {
        return string2.length;
      }
      if (ArrayBuffer.isView(string2) || isInstance(string2, ArrayBuffer)) {
        return string2.byteLength;
      }
      if (typeof string2 !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string2
        );
      }
      const len = string2.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0)
        return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string2).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string2).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string2).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.prototype._isBuffer = true;
    function swap(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer2.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer2.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer2.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer2.prototype.toString = function toString() {
      const length = this.length;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
    Buffer2.prototype.equals = function equals(b) {
      if (!Buffer2.isBuffer(b))
        throw new TypeError("Argument must be a Buffer");
      if (this === b)
        return true;
      return Buffer2.compare(this, b) === 0;
    };
    Buffer2.prototype.inspect = function inspect() {
      let str = "";
      const max = exports.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max)
        str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
    }
    Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer2.from(target, target.offset, target.byteLength);
      }
      if (!Buffer2.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
        );
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val === "string") {
        val = Buffer2.from(val, encoding);
      }
      if (Buffer2.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i;
            if (i - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found)
            return i;
        }
      }
      return -1;
    }
    Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string2, offset, length) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      const strLen = string2.length;
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      let i;
      for (i = 0; i < length; ++i) {
        const parsed = parseInt(string2.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
          return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string2, offset, length) {
      return blitBuffer(utf8ToBytes(string2, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string2, offset, length) {
      return blitBuffer(asciiToBytes(string2), buf, offset, length);
    }
    function base64Write(buf, string2, offset, length) {
      return blitBuffer(base64ToBytes(string2), buf, offset, length);
    }
    function ucs2Write(buf, string2, offset, length) {
      return blitBuffer(utf16leToBytes(string2, buf.length - offset), buf, offset, length);
    }
    Buffer2.prototype.write = function write(string2, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
          length = length >>> 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string2.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string2, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string2, offset, length);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string2, offset, length);
          case "base64":
            return base64Write(this, string2, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string2, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer2.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer2.prototype.slice = function slice(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer2.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
    });
    Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer2.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
      if (!Buffer2.isBuffer(target))
        throw new TypeError("argument should be a Buffer");
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("Index out of range");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        );
      }
      return len;
    };
    Buffer2.prototype.fill = function fill(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val)
        val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base) {
      errors[sym] = class NodeError extends Base {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name) {
        if (name) {
          return `${name} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
          received = addNumericalSeparator(String(input));
        } else if (typeof input === "bigint") {
          received = String(input);
          if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
            received = addNumericalSeparator(received);
          }
          received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min, max, buf, offset, byteLength2) {
      if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength2 > 3) {
          if (min === 0 || min === BigInt(0)) {
            range = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        } else {
          range = `>= ${min}${n} and <= ${max}${n}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length, type) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
      }
      if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type || "offset",
        `>= ${type ? 1 : 0} and <= ${length}`,
        value
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string2, units) {
      units = units || Infinity;
      let codePoint;
      const length = string2.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length; ++i) {
        codePoint = string2.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
          break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      let i;
      for (i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
          break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    }();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// node_modules/safe-buffer/index.js
var require_safe_buffer = __commonJS({
  "node_modules/safe-buffer/index.js"(exports, module) {
    var buffer = require_buffer();
    var Buffer2 = buffer.Buffer;
    function copyProps(src, dst) {
      for (var key in src) {
        dst[key] = src[key];
      }
    }
    if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) {
      module.exports = buffer;
    } else {
      copyProps(buffer, exports);
      exports.Buffer = SafeBuffer;
    }
    function SafeBuffer(arg, encodingOrOffset, length) {
      return Buffer2(arg, encodingOrOffset, length);
    }
    copyProps(Buffer2, SafeBuffer);
    SafeBuffer.from = function(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        throw new TypeError("Argument must not be a number");
      }
      return Buffer2(arg, encodingOrOffset, length);
    };
    SafeBuffer.alloc = function(size, fill, encoding) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      var buf = Buffer2(size);
      if (fill !== void 0) {
        if (typeof encoding === "string") {
          buf.fill(fill, encoding);
        } else {
          buf.fill(fill);
        }
      } else {
        buf.fill(0);
      }
      return buf;
    };
    SafeBuffer.allocUnsafe = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return Buffer2(size);
    };
    SafeBuffer.allocUnsafeSlow = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return buffer.SlowBuffer(size);
    };
  }
});

// node_modules/basic-auth/index.js
var require_basic_auth = __commonJS({
  "node_modules/basic-auth/index.js"(exports, module) {
    "use strict";
    var Buffer2 = require_safe_buffer().Buffer;
    module.exports = auth;
    module.exports.parse = parse2;
    var CREDENTIALS_REGEXP = /^ *(?:[Bb][Aa][Ss][Ii][Cc]) +([A-Za-z0-9._~+/-]+=*) *$/;
    var USER_PASS_REGEXP = /^([^:]*):(.*)$/;
    function auth(req) {
      if (!req) {
        throw new TypeError("argument req is required");
      }
      if (typeof req !== "object") {
        throw new TypeError("argument req is required to be an object");
      }
      var header = getAuthorization(req);
      return parse2(header);
    }
    function decodeBase64(str) {
      return Buffer2.from(str, "base64").toString();
    }
    function getAuthorization(req) {
      if (!req.headers || typeof req.headers !== "object") {
        throw new TypeError("argument req is required to have headers property");
      }
      return req.headers.authorization;
    }
    function parse2(string2) {
      if (typeof string2 !== "string") {
        return void 0;
      }
      var match = CREDENTIALS_REGEXP.exec(string2);
      if (!match) {
        return void 0;
      }
      var userPass = USER_PASS_REGEXP.exec(decodeBase64(match[1]));
      if (!userPass) {
        return void 0;
      }
      return new Credentials(userPass[1], userPass[2]);
    }
    function Credentials(name, pass) {
      this.name = name;
      this.pass = pass;
    }
  }
});

// node_modules/js-base64/base64.mjs
var _TD, _TE, b64ch, b64chs, b64tab, _fromCC, _U8Afrom;
var init_base64 = __esm({
  "node_modules/js-base64/base64.mjs"() {
    _TD = typeof TextDecoder === "function" ? new TextDecoder() : void 0;
    _TE = typeof TextEncoder === "function" ? new TextEncoder() : void 0;
    b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    b64chs = Array.prototype.slice.call(b64ch);
    b64tab = ((a) => {
      let tab = {};
      a.forEach((c, i) => tab[c] = i);
      return tab;
    })(b64chs);
    _fromCC = String.fromCharCode.bind(String);
    _U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it, fn = (x) => x) => new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
  }
});

// src/core/auth/BasicAuth.ts
var import_basic_auth;
var init_BasicAuth = __esm({
  "src/core/auth/BasicAuth.ts"() {
    "use strict";
    import_basic_auth = __toESM(require_basic_auth());
    init_base64();
  }
});

// src/core/auth/BearerToken.ts
var BEARER_AUTH_HEADER_PREFIX, BearerToken;
var init_BearerToken = __esm({
  "src/core/auth/BearerToken.ts"() {
    "use strict";
    BEARER_AUTH_HEADER_PREFIX = /^Bearer /i;
    BearerToken = {
      toAuthorizationHeader: (token) => {
        if (token == null) {
          return void 0;
        }
        return `Bearer ${token}`;
      },
      fromAuthorizationHeader: (header) => {
        return header.replace(BEARER_AUTH_HEADER_PREFIX, "").trim();
      }
    };
  }
});

// src/core/auth/index.ts
var init_auth = __esm({
  "src/core/auth/index.ts"() {
    "use strict";
    init_BasicAuth();
    init_BearerToken();
  }
});

// node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    var kindOf = function(cache) {
      return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
      };
    }(/* @__PURE__ */ Object.create(null));
    function kindOfTest(type) {
      type = type.toLowerCase();
      return function isKindOf(thing) {
        return kindOf(thing) === type;
      };
    }
    function isArray(val) {
      return Array.isArray(val);
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    var isArrayBuffer = kindOfTest("ArrayBuffer");
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && isArrayBuffer(val.buffer);
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject2(val) {
      if (kindOf(val) !== "object") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    var isDate = kindOfTest("Date");
    var isFile = kindOfTest("File");
    var isBlob = kindOfTest("Blob");
    var isFileList = kindOfTest("FileList");
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isFormData(thing) {
      var pattern = "[object FormData]";
      return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
    }
    var isURLSearchParams = kindOfTest("URLSearchParams");
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject2(result[key]) && isPlainObject2(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject2(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    function inherits(constructor, superConstructor, props, descriptors) {
      constructor.prototype = Object.create(superConstructor.prototype, descriptors);
      constructor.prototype.constructor = constructor;
      props && Object.assign(constructor.prototype, props);
    }
    function toFlatObject(sourceObj, destObj, filter) {
      var props;
      var i;
      var prop;
      var merged = {};
      destObj = destObj || {};
      do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while (i-- > 0) {
          prop = props[i];
          if (!merged[prop]) {
            destObj[prop] = sourceObj[prop];
            merged[prop] = true;
          }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
      } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
      return destObj;
    }
    function endsWith(str, searchString, position) {
      str = String(str);
      if (position === void 0 || position > str.length) {
        position = str.length;
      }
      position -= searchString.length;
      var lastIndex = str.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
    function toArray(thing) {
      if (!thing)
        return null;
      var i = thing.length;
      if (isUndefined(i))
        return null;
      var arr = new Array(i);
      while (i-- > 0) {
        arr[i] = thing[i];
      }
      return arr;
    }
    var isTypedArray = function(TypedArray) {
      return function(thing) {
        return TypedArray && thing instanceof TypedArray;
      };
    }(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
    module.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject: isPlainObject2,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM,
      inherits,
      toFlatObject,
      kindOf,
      kindOfTest,
      endsWith,
      toArray,
      isTypedArray,
      isFileList
    };
  }
});

// node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/axios/lib/core/AxiosError.js
var require_AxiosError = __commonJS({
  "node_modules/axios/lib/core/AxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function AxiosError2(message, code, config, request, response) {
      Error.call(this);
      this.message = message;
      this.name = "AxiosError";
      code && (this.code = code);
      config && (this.config = config);
      request && (this.request = request);
      response && (this.response = response);
    }
    utils.inherits(AxiosError2, Error, {
      toJSON: function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var prototype = AxiosError2.prototype;
    var descriptors = {};
    [
      "ERR_BAD_OPTION_VALUE",
      "ERR_BAD_OPTION",
      "ECONNABORTED",
      "ETIMEDOUT",
      "ERR_NETWORK",
      "ERR_FR_TOO_MANY_REDIRECTS",
      "ERR_DEPRECATED",
      "ERR_BAD_RESPONSE",
      "ERR_BAD_REQUEST",
      "ERR_CANCELED"
      // eslint-disable-next-line func-names
    ].forEach(function(code) {
      descriptors[code] = { value: code };
    });
    Object.defineProperties(AxiosError2, descriptors);
    Object.defineProperty(prototype, "isAxiosError", { value: true });
    AxiosError2.from = function(error, code, config, request, response, customProps) {
      var axiosError = Object.create(prototype);
      utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
      });
      AxiosError2.call(axiosError, error.message, code, config, request, response);
      axiosError.name = error.name;
      customProps && Object.assign(axiosError, customProps);
      return axiosError;
    };
    module.exports = AxiosError2;
  }
});

// node_modules/axios/lib/defaults/transitional.js
var require_transitional = __commonJS({
  "node_modules/axios/lib/defaults/transitional.js"(exports, module) {
    "use strict";
    module.exports = {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    };
  }
});

// node_modules/axios/lib/helpers/toFormData.js
var require_toFormData = __commonJS({
  "node_modules/axios/lib/helpers/toFormData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function toFormData(obj, formData) {
      formData = formData || new FormData();
      var stack = [];
      function convertValue(value) {
        if (value === null)
          return "";
        if (utils.isDate(value)) {
          return value.toISOString();
        }
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
          return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
        }
        return value;
      }
      function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
          if (stack.indexOf(data) !== -1) {
            throw Error("Circular reference detected in " + parentKey);
          }
          stack.push(data);
          utils.forEach(data, function each(value, key) {
            if (utils.isUndefined(value))
              return;
            var fullKey = parentKey ? parentKey + "." + key : key;
            var arr;
            if (value && !parentKey && typeof value === "object") {
              if (utils.endsWith(key, "{}")) {
                value = JSON.stringify(value);
              } else if (utils.endsWith(key, "[]") && (arr = utils.toArray(value))) {
                arr.forEach(function(el) {
                  !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                });
                return;
              }
            }
            build(value, fullKey);
          });
          stack.pop();
        } else {
          formData.append(parentKey, convertValue(data));
        }
      }
      build(obj);
      return formData;
    }
    module.exports = toFormData;
  }
});

// node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(new AxiosError2(
          "Request failed with status code " + response.status,
          [AxiosError2.ERR_BAD_REQUEST, AxiosError2.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
          response.config,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }() : function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }();
  }
});

// node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    };
  }
});

// node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();
  }
});

// node_modules/axios/lib/cancel/CanceledError.js
var require_CanceledError = __commonJS({
  "node_modules/axios/lib/cancel/CanceledError.js"(exports, module) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    var utils = require_utils();
    function CanceledError(message) {
      AxiosError2.call(this, message == null ? "canceled" : message, AxiosError2.ERR_CANCELED);
      this.name = "CanceledError";
    }
    utils.inherits(CanceledError, AxiosError2, {
      __CANCEL__: true
    });
    module.exports = CanceledError;
  }
});

// node_modules/axios/lib/helpers/parseProtocol.js
var require_parseProtocol = __commonJS({
  "node_modules/axios/lib/helpers/parseProtocol.js"(exports, module) {
    "use strict";
    module.exports = function parseProtocol(url) {
      var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
      return match && match[1] || "";
    };
  }
});

// node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var transitionalDefaults = require_transitional();
    var AxiosError2 = require_AxiosError();
    var CanceledError = require_CanceledError();
    var parseProtocol = require_parseProtocol();
    module.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(new AxiosError2("Request aborted", AxiosError2.ECONNABORTED, config, request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(new AxiosError2("Network Error", AxiosError2.ERR_NETWORK, config, request, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || transitionalDefaults;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(new AxiosError2(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? AxiosError2.ETIMEDOUT : AxiosError2.ECONNABORTED,
            config,
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        var protocol = parseProtocol(fullPath);
        if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
          reject(new AxiosError2("Unsupported protocol " + protocol + ":", AxiosError2.ERR_BAD_REQUEST, config));
          return;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/axios/lib/helpers/null.js
var require_null = __commonJS({
  "node_modules/axios/lib/helpers/null.js"(exports, module) {
    module.exports = null;
  }
});

// node_modules/axios/lib/defaults/index.js
var require_defaults = __commonJS({
  "node_modules/axios/lib/defaults/index.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var AxiosError2 = require_AxiosError();
    var transitionalDefaults = require_transitional();
    var toFormData = require_toFormData();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: transitionalDefaults,
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        var isObjectPayload = utils.isObject(data);
        var contentType = headers && headers["Content-Type"];
        var isFileList;
        if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
          var _FormData = this.env && this.env.FormData;
          return toFormData(isFileList ? { "files[]": data } : data, _FormData && new _FormData());
        } else if (isObjectPayload || contentType === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw AxiosError2.from(e, AxiosError2.ERR_BAD_RESPONSE, this, null, this.response);
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: require_null()
      },
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform2(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var CanceledError = require_CanceledError();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new CanceledError();
      }
    }
    module.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.27.2"
    };
  }
});

// node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var AxiosError2 = require_AxiosError();
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new AxiosError2(
            formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
            AxiosError2.ERR_DEPRECATED
          );
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new AxiosError2("options must be an object", AxiosError2.ERR_BAD_OPTION_VALUE);
      }
      var keys2 = Object.keys(options);
      var i = keys2.length;
      while (i-- > 0) {
        var opt = keys2[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new AxiosError2("option " + opt + " must be " + result, AxiosError2.ERR_BAD_OPTION_VALUE);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw new AxiosError2("Unknown option " + opt, AxiosError2.ERR_BAD_OPTION);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var buildFullPath = require_buildFullPath();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      var fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
          return this.request(mergeConfig(config || {}, {
            method,
            headers: isForm ? {
              "Content-Type": "multipart/form-data"
            } : {},
            url,
            data
          }));
        };
      }
      Axios.prototype[method] = generateHTTPMethod();
      Axios.prototype[method + "Form"] = generateHTTPMethod(true);
    });
    module.exports = Axios;
  }
});

// node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var CanceledError = require_CanceledError();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.CanceledError = require_CanceledError();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.VERSION = require_data().version;
    axios2.toFormData = require_toFormData();
    axios2.AxiosError = require_AxiosError();
    axios2.Cancel = axios2.CanceledError;
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module.exports = axios2;
    module.exports.default = axios2;
  }
});

// node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// src/core/fetcher/Fetcher.ts
var import_axios, fetcher;
var init_Fetcher = __esm({
  "src/core/fetcher/Fetcher.ts"() {
    "use strict";
    import_axios = __toESM(require_axios2());
    fetcher = async (args) => {
      const headers = {
        "Content-Type": "application/json"
      };
      if (args.headers != null) {
        for (const [key, value] of Object.entries(args.headers)) {
          if (value != null) {
            headers[key] = value;
          }
        }
      }
      try {
        const response = await (0, import_axios.default)({
          url: args.url,
          params: args.queryParameters,
          method: args.method,
          headers,
          data: args.body,
          validateStatus: () => true,
          transformResponse: (response2) => response2,
          timeout: args.timeoutMs ?? 6e4,
          transitional: {
            clarifyTimeoutError: true
          },
          withCredentials: args.withCredentials
        });
        let body;
        if (response.data != null && response.data.length > 0) {
          try {
            body = JSON.parse(response.data) ?? void 0;
          } catch {
            return {
              ok: false,
              error: {
                reason: "non-json",
                statusCode: response.status,
                rawBody: response.data
              }
            };
          }
        }
        if (response.status >= 200 && response.status < 300) {
          return {
            ok: true,
            body
          };
        } else {
          return {
            ok: false,
            error: {
              reason: "status-code",
              statusCode: response.status,
              body
            }
          };
        }
      } catch (error) {
        if (error.code === "ETIMEDOUT") {
          return {
            ok: false,
            error: {
              reason: "timeout"
            }
          };
        }
        return {
          ok: false,
          error: {
            reason: "unknown",
            errorMessage: error.message
          }
        };
      }
    };
  }
});

// src/core/fetcher/Supplier.ts
var Supplier;
var init_Supplier = __esm({
  "src/core/fetcher/Supplier.ts"() {
    "use strict";
    Supplier = {
      get: async (supplier) => {
        if (typeof supplier === "function") {
          return supplier();
        } else {
          return supplier;
        }
      }
    };
  }
});

// src/core/fetcher/index.ts
var init_fetcher = __esm({
  "src/core/fetcher/index.ts"() {
    "use strict";
    init_Fetcher();
    init_Supplier();
  }
});

// src/core/index.ts
var init_core = __esm({
  "src/core/index.ts"() {
    "use strict";
    init_schemas();
    init_auth();
    init_fetcher();
  }
});

// node_modules/url-join/lib/url-join.js
var require_url_join = __commonJS({
  "node_modules/url-join/lib/url-join.js"(exports, module) {
    (function(name, context, definition) {
      if (typeof module !== "undefined" && module.exports)
        module.exports = definition();
      else if (typeof define === "function" && define.amd)
        define(definition);
      else
        context[name] = definition();
    })("urljoin", exports, function() {
      function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) {
          return "";
        }
        if (typeof strArray[0] !== "string") {
          throw new TypeError("Url must be a string. Received " + strArray[0]);
        }
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
          var first = strArray.shift();
          strArray[0] = first + strArray[0];
        }
        if (strArray[0].match(/^file:\/\/\//)) {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
        } else {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        }
        for (var i = 0; i < strArray.length; i++) {
          var component = strArray[i];
          if (typeof component !== "string") {
            throw new TypeError("Url must be a string. Received " + component);
          }
          if (component === "") {
            continue;
          }
          if (i > 0) {
            component = component.replace(/^[\/]+/, "");
          }
          if (i < strArray.length - 1) {
            component = component.replace(/[\/]+$/, "");
          } else {
            component = component.replace(/[\/]+$/, "/");
          }
          resultArray.push(component);
        }
        var str = resultArray.join("/");
        str = str.replace(/\/(\?|&|#[^!])/g, "$1");
        var parts = str.split("?");
        str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        return str;
      }
      return function() {
        var input;
        if (typeof arguments[0] === "object") {
          input = arguments[0];
        } else {
          input = [].slice.call(arguments);
        }
        return normalize(input);
      };
    });
  }
});

// src/serialization/resources/analytics/types/EventsResponse.ts
var EventsResponse;
var init_EventsResponse2 = __esm({
  "src/serialization/resources/analytics/types/EventsResponse.ts"() {
    "use strict";
    init_core();
    EventsResponse = schemas_exports.object({
      views: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).ViewEvent)),
      searches: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).SearchEvent)
      ),
      ratings: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).GuideRatedEvent)
      ),
      feedback: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).FeedbackEvent)
      )
    });
  }
});

// src/serialization/resources/analytics/types/ViewEvent.ts
var ViewEvent;
var init_ViewEvent2 = __esm({
  "src/serialization/resources/analytics/types/ViewEvent.ts"() {
    "use strict";
    init_core();
    ViewEvent = schemas_exports.object({
      event: schemas_exports.string(),
      date: schemas_exports.string(),
      guideId: schemas_exports.string(),
      title: schemas_exports.string(),
      count: schemas_exports.number()
    });
  }
});

// src/serialization/resources/analytics/types/GuideRatedEvent.ts
var GuideRatedEvent;
var init_GuideRatedEvent2 = __esm({
  "src/serialization/resources/analytics/types/GuideRatedEvent.ts"() {
    "use strict";
    init_core();
    GuideRatedEvent = schemas_exports.object({
      rating: schemas_exports.number(),
      guideId: schemas_exports.string(),
      title: schemas_exports.string(),
      date: schemas_exports.string()
    });
  }
});

// src/serialization/resources/analytics/types/SearchEvent.ts
var SearchEvent;
var init_SearchEvent2 = __esm({
  "src/serialization/resources/analytics/types/SearchEvent.ts"() {
    "use strict";
    init_core();
    SearchEvent = schemas_exports.object({
      event: schemas_exports.string(),
      date: schemas_exports.string(),
      search: schemas_exports.string()
    });
  }
});

// src/serialization/resources/analytics/types/FeedbackEvent.ts
var FeedbackEvent;
var init_FeedbackEvent2 = __esm({
  "src/serialization/resources/analytics/types/FeedbackEvent.ts"() {
    "use strict";
    init_core();
    FeedbackEvent = schemas_exports.object({
      guideId: schemas_exports.string(),
      title: schemas_exports.string(),
      date: schemas_exports.string(),
      feedback: schemas_exports.string()
    });
  }
});

// src/serialization/resources/analytics/types/DashboardToken.ts
var DashboardToken;
var init_DashboardToken2 = __esm({
  "src/serialization/resources/analytics/types/DashboardToken.ts"() {
    "use strict";
    init_core();
    DashboardToken = schemas_exports.object({
      dashboardAccessToken: schemas_exports.string(),
      dataAccessTokens: schemas_exports.string().optional(),
      queryAccessToken: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/analytics/types/index.ts
var init_types11 = __esm({
  "src/serialization/resources/analytics/types/index.ts"() {
    "use strict";
    init_EventsResponse2();
    init_ViewEvent2();
    init_GuideRatedEvent2();
    init_SearchEvent2();
    init_FeedbackEvent2();
    init_DashboardToken2();
  }
});

// src/serialization/resources/analytics/client/getEventData.ts
var getEventData_exports2 = {};
__export(getEventData_exports2, {
  Error: () => Error69
});
var Error69;
var init_getEventData2 = __esm({
  "src/serialization/resources/analytics/client/getEventData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error69 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.analytics.getEventData.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/analytics/client/index.ts
var init_client13 = __esm({
  "src/serialization/resources/analytics/client/index.ts"() {
    "use strict";
    init_getEventData2();
  }
});

// src/serialization/resources/analytics/index.ts
var analytics_exports2 = {};
__export(analytics_exports2, {
  DashboardToken: () => DashboardToken,
  EventsResponse: () => EventsResponse,
  FeedbackEvent: () => FeedbackEvent,
  GuideRatedEvent: () => GuideRatedEvent,
  SearchEvent: () => SearchEvent,
  ViewEvent: () => ViewEvent,
  getEventData: () => getEventData_exports2
});
var init_analytics2 = __esm({
  "src/serialization/resources/analytics/index.ts"() {
    "use strict";
    init_types11();
    init_client13();
  }
});

// src/serialization/resources/audio/types/Transcript.ts
var Transcript;
var init_Transcript2 = __esm({
  "src/serialization/resources/audio/types/Transcript.ts"() {
    "use strict";
    init_core();
    Transcript = schemas_exports.unknown();
  }
});

// src/serialization/resources/audio/types/index.ts
var init_types12 = __esm({
  "src/serialization/resources/audio/types/index.ts"() {
    "use strict";
    init_Transcript2();
  }
});

// src/serialization/resources/audio/client/getTranscript.ts
var getTranscript_exports2 = {};
__export(getTranscript_exports2, {
  Error: () => Error70
});
var Error70;
var init_getTranscript2 = __esm({
  "src/serialization/resources/audio/client/getTranscript.ts"() {
    "use strict";
    init_src();
    init_core();
    Error70 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.getTranscript.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/saveAudio.ts
var saveAudio_exports2 = {};
__export(saveAudio_exports2, {
  Error: () => Error71
});
var Error71;
var init_saveAudio2 = __esm({
  "src/serialization/resources/audio/client/saveAudio.ts"() {
    "use strict";
    init_src();
    init_core();
    Error71 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.saveAudio.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/saveGuideAudio.ts
var saveGuideAudio_exports2 = {};
__export(saveGuideAudio_exports2, {
  Error: () => Error72
});
var Error72;
var init_saveGuideAudio2 = __esm({
  "src/serialization/resources/audio/client/saveGuideAudio.ts"() {
    "use strict";
    init_src();
    init_core();
    Error72 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.audio.saveGuideAudio.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/audio/client/requests/GetTranscriptRequest.ts
var GetTranscriptRequest;
var init_GetTranscriptRequest = __esm({
  "src/serialization/resources/audio/client/requests/GetTranscriptRequest.ts"() {
    "use strict";
    init_core();
    GetTranscriptRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      language: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/audio/client/requests/index.ts
var init_requests8 = __esm({
  "src/serialization/resources/audio/client/requests/index.ts"() {
    "use strict";
    init_GetTranscriptRequest();
  }
});

// src/serialization/resources/audio/client/index.ts
var init_client14 = __esm({
  "src/serialization/resources/audio/client/index.ts"() {
    "use strict";
    init_getTranscript2();
    init_saveAudio2();
    init_saveGuideAudio2();
    init_requests8();
  }
});

// src/serialization/resources/audio/index.ts
var audio_exports2 = {};
__export(audio_exports2, {
  GetTranscriptRequest: () => GetTranscriptRequest,
  Transcript: () => Transcript,
  getTranscript: () => getTranscript_exports2,
  saveAudio: () => saveAudio_exports2,
  saveGuideAudio: () => saveGuideAudio_exports2
});
var init_audio2 = __esm({
  "src/serialization/resources/audio/index.ts"() {
    "use strict";
    init_types12();
    init_client14();
  }
});

// src/serialization/resources/baseTypes/types/Id.ts
var Id2;
var init_Id2 = __esm({
  "src/serialization/resources/baseTypes/types/Id.ts"() {
    "use strict";
    init_src();
    init_core();
    Id2 = schemas_exports.string().transform({
      transform: api_exports.Id,
      untransform: (value) => value
    });
  }
});

// src/serialization/resources/baseTypes/types/PresignedUrl.ts
var PresignedUrl;
var init_PresignedUrl2 = __esm({
  "src/serialization/resources/baseTypes/types/PresignedUrl.ts"() {
    "use strict";
    init_core();
    PresignedUrl = schemas_exports.unknown();
  }
});

// src/serialization/resources/baseTypes/types/SimpleResponse.ts
var SimpleResponse;
var init_SimpleResponse2 = __esm({
  "src/serialization/resources/baseTypes/types/SimpleResponse.ts"() {
    "use strict";
    init_core();
    SimpleResponse = schemas_exports.object({
      response: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/baseTypes/types/GetChildrenRequest.ts
var GetChildrenRequest;
var init_GetChildrenRequest2 = __esm({
  "src/serialization/resources/baseTypes/types/GetChildrenRequest.ts"() {
    "use strict";
    init_core();
    GetChildrenRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      )
    });
  }
});

// src/serialization/resources/baseTypes/types/IdRequest.ts
var IdRequest;
var init_IdRequest2 = __esm({
  "src/serialization/resources/baseTypes/types/IdRequest.ts"() {
    "use strict";
    init_core();
    IdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/baseTypes/types/Token.ts
var Token;
var init_Token2 = __esm({
  "src/serialization/resources/baseTypes/types/Token.ts"() {
    "use strict";
    init_core();
    Token = schemas_exports.object({
      tokenId: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/VideoFormat.ts
var VideoFormat;
var init_VideoFormat2 = __esm({
  "src/serialization/resources/baseTypes/types/VideoFormat.ts"() {
    "use strict";
    init_core();
    VideoFormat = schemas_exports.object({
      container: schemas_exports.string(),
      codec: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/S3Object.ts
var S3Object;
var init_S3Object2 = __esm({
  "src/serialization/resources/baseTypes/types/S3Object.ts"() {
    "use strict";
    init_core();
    S3Object = schemas_exports.object({
      region: schemas_exports.string(),
      bucket: schemas_exports.string(),
      key: schemas_exports.string()
    });
  }
});

// src/serialization/resources/baseTypes/types/index.ts
var init_types13 = __esm({
  "src/serialization/resources/baseTypes/types/index.ts"() {
    "use strict";
    init_Id2();
    init_PresignedUrl2();
    init_SimpleResponse2();
    init_GetChildrenRequest2();
    init_IdRequest2();
    init_Token2();
    init_VideoFormat2();
    init_S3Object2();
  }
});

// src/serialization/resources/baseTypes/index.ts
var baseTypes_exports2 = {};
__export(baseTypes_exports2, {
  GetChildrenRequest: () => GetChildrenRequest,
  Id: () => Id2,
  IdRequest: () => IdRequest,
  PresignedUrl: () => PresignedUrl,
  S3Object: () => S3Object,
  SimpleResponse: () => SimpleResponse,
  Token: () => Token,
  VideoFormat: () => VideoFormat
});
var init_baseTypes2 = __esm({
  "src/serialization/resources/baseTypes/index.ts"() {
    "use strict";
    init_types13();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts
var MoveCollectionRequest;
var init_MoveCollectionRequest2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/MoveCollectionRequest.ts"() {
    "use strict";
    init_core();
    MoveCollectionRequest = schemas_exports.object({
      collection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection),
      newParentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/types/index.ts
var init_types14 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/types/index.ts"() {
    "use strict";
    init_MoveCollectionRequest2();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/createCollection.ts
var createCollection_exports2 = {};
__export(createCollection_exports2, {
  Error: () => Error73
});
var Error73;
var init_createCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/createCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error73 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.createCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.createCollection.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/updateCollection.ts
var updateCollection_exports2 = {};
__export(updateCollection_exports2, {
  Error: () => Error74
});
var Error74;
var init_updateCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/updateCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error74 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.updateCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.updateCollection.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/moveCollection.ts
var moveCollection_exports2 = {};
__export(moveCollection_exports2, {
  Error: () => Error75
});
var Error75;
var init_moveCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/moveCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error75 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.moveCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.moveCollection.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/deleteCollection.ts
var deleteCollection_exports2 = {};
__export(deleteCollection_exports2, {
  Error: () => Error76
});
var Error76;
var init_deleteCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/deleteCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error76 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.deleteCollection.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/reorderCollection.ts
var reorderCollection_exports2 = {};
__export(reorderCollection_exports2, {
  Error: () => Error77
});
var Error77;
var init_reorderCollection2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/reorderCollection.ts"() {
    "use strict";
    init_src();
    init_core();
    Error77 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.reorderCollection.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts
var setCollectionVisibility_exports2 = {};
__export(setCollectionVisibility_exports2, {
  Error: () => Error78
});
var Error78;
var init_setCollectionVisibility2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/setCollectionVisibility.ts"() {
    "use strict";
    init_src();
    init_core();
    Error78 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionMutations.setCollectionVisibility.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/DeleteCollectionRequest.ts
var DeleteCollectionRequest;
var init_DeleteCollectionRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/DeleteCollectionRequest.ts"() {
    "use strict";
    init_core();
    DeleteCollectionRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/ReorderCollectionRequest.ts
var ReorderCollectionRequest;
var init_ReorderCollectionRequest = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/ReorderCollectionRequest.ts"() {
    "use strict";
    init_core();
    ReorderCollectionRequest = schemas_exports.object({
      succeedingCollection: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection
      ),
      precedingCollection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection).optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/SetCollectionVisibility.ts
var SetCollectionVisibility;
var init_SetCollectionVisibility = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/SetCollectionVisibility.ts"() {
    "use strict";
    init_core();
    SetCollectionVisibility = schemas_exports.object({
      collection: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection),
      private: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/requests/index.ts
var init_requests9 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/requests/index.ts"() {
    "use strict";
    init_DeleteCollectionRequest();
    init_ReorderCollectionRequest();
    init_SetCollectionVisibility();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/client/index.ts
var init_client15 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/client/index.ts"() {
    "use strict";
    init_createCollection2();
    init_updateCollection2();
    init_moveCollection2();
    init_deleteCollection2();
    init_reorderCollection2();
    init_setCollectionVisibility2();
    init_requests9();
  }
});

// src/serialization/resources/collections/resources/collectionMutations/index.ts
var collectionMutations_exports2 = {};
__export(collectionMutations_exports2, {
  DeleteCollectionRequest: () => DeleteCollectionRequest,
  MoveCollectionRequest: () => MoveCollectionRequest,
  ReorderCollectionRequest: () => ReorderCollectionRequest,
  SetCollectionVisibility: () => SetCollectionVisibility,
  createCollection: () => createCollection_exports2,
  deleteCollection: () => deleteCollection_exports2,
  moveCollection: () => moveCollection_exports2,
  reorderCollection: () => reorderCollection_exports2,
  setCollectionVisibility: () => setCollectionVisibility_exports2,
  updateCollection: () => updateCollection_exports2
});
var init_collectionMutations2 = __esm({
  "src/serialization/resources/collections/resources/collectionMutations/index.ts"() {
    "use strict";
    init_types14();
    init_client15();
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/CollectionInput.ts
var CollectionInput;
var init_CollectionInput2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/CollectionInput.ts"() {
    "use strict";
    init_core();
    CollectionInput = schemas_exports.object({
      name: schemas_exports.string(),
      description: schemas_exports.string().optional(),
      sequenceNumber: schemas_exports.property("sequence_number", schemas_exports.number().optional()),
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      private: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/Collection.ts
var Collection;
var init_Collection2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/Collection.ts"() {
    "use strict";
    init_core();
    Collection = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.CollectionInput));
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts
var GetCollectionsResponse;
var init_GetCollectionsResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/GetCollectionsResponse.ts"() {
    "use strict";
    init_core();
    GetCollectionsResponse = schemas_exports.object({
      collections: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts
var GetAllChildrenResponse;
var init_GetAllChildrenResponse2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/GetAllChildrenResponse.ts"() {
    "use strict";
    init_core();
    GetAllChildrenResponse = schemas_exports.object({
      collections: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
      ),
      guides: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
      )
    });
  }
});

// src/serialization/resources/collections/resources/collectionTypes/types/index.ts
var init_types15 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/types/index.ts"() {
    "use strict";
    init_CollectionInput2();
    init_Collection2();
    init_GetCollectionsResponse2();
    init_GetAllChildrenResponse2();
  }
});

// src/serialization/resources/collections/resources/collectionTypes/index.ts
var collectionTypes_exports2 = {};
__export(collectionTypes_exports2, {
  Collection: () => Collection,
  CollectionInput: () => CollectionInput,
  GetAllChildrenResponse: () => GetAllChildrenResponse,
  GetCollectionsResponse: () => GetCollectionsResponse
});
var init_collectionTypes2 = __esm({
  "src/serialization/resources/collections/resources/collectionTypes/index.ts"() {
    "use strict";
    init_types15();
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getCollections.ts
var getCollections_exports3 = {};
__export(getCollections_exports3, {
  Error: () => Error79
});
var Error79;
var init_getCollections3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Error79 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getCollections.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getAllChildren.ts
var getAllChildren_exports3 = {};
__export(getAllChildren_exports3, {
  Error: () => Error80
});
var Error80;
var init_getAllChildren3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    init_core();
    Error80 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getAllChildren.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getAllCollections.ts
var getAllCollections_exports3 = {};
__export(getAllCollections_exports3, {
  Error: () => Error81,
  Response: () => Response
});
var Response, Error81;
var init_getAllCollections3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Response = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
    );
    Error81 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getAllCollections.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/getPath.ts
var getPath_exports3 = {};
__export(getPath_exports3, {
  Error: () => Error82
});
var Error82;
var init_getPath3 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error82 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.collections.collectionQueries.getPath.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.collections.collectionQueries.getPath.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/collections/resources/collectionQueries/client/index.ts
var init_client16 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/client/index.ts"() {
    "use strict";
    init_getCollections3();
    init_getAllChildren3();
    init_getAllCollections3();
    init_getPath3();
  }
});

// src/serialization/resources/collections/resources/collectionQueries/index.ts
var collectionQueries_exports2 = {};
__export(collectionQueries_exports2, {
  getAllChildren: () => getAllChildren_exports3,
  getAllCollections: () => getAllCollections_exports3,
  getCollections: () => getCollections_exports3,
  getPath: () => getPath_exports3
});
var init_collectionQueries2 = __esm({
  "src/serialization/resources/collections/resources/collectionQueries/index.ts"() {
    "use strict";
    init_client16();
  }
});

// src/serialization/resources/collections/resources/index.ts
var init_resources5 = __esm({
  "src/serialization/resources/collections/resources/index.ts"() {
    "use strict";
    init_collectionMutations2();
    init_types14();
    init_collectionTypes2();
    init_types15();
    init_collectionQueries2();
    init_requests9();
  }
});

// src/serialization/resources/collections/index.ts
var collections_exports2 = {};
__export(collections_exports2, {
  Collection: () => Collection,
  CollectionInput: () => CollectionInput,
  DeleteCollectionRequest: () => DeleteCollectionRequest,
  GetAllChildrenResponse: () => GetAllChildrenResponse,
  GetCollectionsResponse: () => GetCollectionsResponse,
  MoveCollectionRequest: () => MoveCollectionRequest,
  ReorderCollectionRequest: () => ReorderCollectionRequest,
  SetCollectionVisibility: () => SetCollectionVisibility,
  collectionMutations: () => collectionMutations_exports2,
  collectionQueries: () => collectionQueries_exports2,
  collectionTypes: () => collectionTypes_exports2
});
var init_collections2 = __esm({
  "src/serialization/resources/collections/index.ts"() {
    "use strict";
    init_resources5();
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts
var InitiateCreateGuideRequest;
var init_InitiateCreateGuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateGuideRequest.ts"() {
    "use strict";
    init_core();
    InitiateCreateGuideRequest = schemas_exports.object({
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts
var InitiateCreateVideoGuideResponse;
var init_InitiateCreateVideoGuideResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/InitiateCreateVideoGuideResponse.ts"() {
    "use strict";
    init_core();
    InitiateCreateVideoGuideResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts
var MoveGuideRequest;
var init_MoveGuideRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/MoveGuideRequest.ts"() {
    "use strict";
    init_core();
    MoveGuideRequest = schemas_exports.object({
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      newParentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/PlainDocRequest.ts
var PlainDocRequest;
var init_PlainDocRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/PlainDocRequest.ts"() {
    "use strict";
    init_core();
    PlainDocRequest = schemas_exports.object({
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts
var GenerateVideoRequest;
var init_GenerateVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/GenerateVideoRequest.ts"() {
    "use strict";
    init_core();
    GenerateVideoRequest = schemas_exports.object({
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/GenerateEditedVideoRequest.ts
var GenerateEditedVideoRequest;
var init_GenerateEditedVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/GenerateEditedVideoRequest.ts"() {
    "use strict";
    init_core();
    GenerateEditedVideoRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      clips: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoClip)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts
var GenerateBookendsVideoRequest;
var init_GenerateBookendsVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/GenerateBookendsVideoRequest.ts"() {
    "use strict";
    init_core();
    GenerateBookendsVideoRequest = schemas_exports.object({
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      doc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      outroSmallText: schemas_exports.string().optional(),
      outroLargeText: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/UpdateVideoEditsRequest.ts
var UpdateVideoEditsRequest;
var init_UpdateVideoEditsRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/UpdateVideoEditsRequest.ts"() {
    "use strict";
    init_core();
    UpdateVideoEditsRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      videoEdits: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.VideoEdits)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts
var UploadChunkRequest;
var init_UploadChunkRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/UploadChunkRequest.ts"() {
    "use strict";
    init_core();
    UploadChunkRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      chunkNumber: schemas_exports.number(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts
var CompileVideoRequest;
var init_CompileVideoRequest2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/CompileVideoRequest.ts"() {
    "use strict";
    init_core();
    CompileVideoRequest = schemas_exports.object({
      guideId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      totalChunks: schemas_exports.number(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts
var CompileVideoResponse;
var init_CompileVideoResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/CompileVideoResponse.ts"() {
    "use strict";
    init_core();
    CompileVideoResponse = schemas_exports.object({
      status: schemas_exports.boolean(),
      url: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts
var ExportGuideResponse;
var init_ExportGuideResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/ExportGuideResponse.ts"() {
    "use strict";
    init_core();
    ExportGuideResponse = schemas_exports.object({
      imagePresignedUrls: schemas_exports.list(
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)
      ),
      hostedImageUrls: schemas_exports.list(schemas_exports.string()),
      hostedVideoUrl: schemas_exports.string(),
      gifUrl: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/types/index.ts
var init_types16 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/types/index.ts"() {
    "use strict";
    init_InitiateCreateGuideRequest2();
    init_InitiateCreateVideoGuideResponse2();
    init_MoveGuideRequest2();
    init_PlainDocRequest2();
    init_GenerateVideoRequest2();
    init_GenerateEditedVideoRequest2();
    init_GenerateBookendsVideoRequest2();
    init_UpdateVideoEditsRequest2();
    init_UploadChunkRequest2();
    init_CompileVideoRequest2();
    init_CompileVideoResponse2();
    init_ExportGuideResponse2();
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/generateVideo.ts
var generateVideo_exports2 = {};
__export(generateVideo_exports2, {
  Error: () => Error83,
  Response: () => Response2
});
var Response2, Error83;
var init_generateVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/generateVideo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response2 = schemas_exports.string();
    Error83 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.generateVideo.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/generateEditedVideo.ts
var generateEditedVideo_exports2 = {};
__export(generateEditedVideo_exports2, {
  Error: () => Error84,
  Response: () => Response3
});
var Response3, Error84;
var init_generateEditedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/generateEditedVideo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response3 = schemas_exports.string();
    Error84 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.generateEditedVideo.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.generateEditedVideo.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/generateBookendsVideo.ts
var generateBookendsVideo_exports2 = {};
__export(generateBookendsVideo_exports2, {
  Error: () => Error85,
  Response: () => Response4
});
var Response4, Error85;
var init_generateBookendsVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/generateBookendsVideo.ts"() {
    "use strict";
    init_core();
    init_src();
    Response4 = schemas_exports.string();
    Error85 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.generateBookendsVideo.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.generateBookendsVideo.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/enhance.ts
var enhance_exports2 = {};
__export(enhance_exports2, {
  Error: () => Error86
});
var Error86;
var init_enhance2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/enhance.ts"() {
    "use strict";
    init_src();
    init_core();
    Error86 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.enhance.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/enhanceVideoTranscript.ts
var enhanceVideoTranscript_exports2 = {};
__export(enhanceVideoTranscript_exports2, {
  Error: () => Error87
});
var Error87;
var init_enhanceVideoTranscript2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/enhanceVideoTranscript.ts"() {
    "use strict";
    init_src();
    init_core();
    Error87 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.enhanceVideoTranscript.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/getLoomToken.ts
var getLoomToken_exports2 = {};
__export(getLoomToken_exports2, {
  Error: () => Error88,
  Response: () => Response5
});
var Response5, Error88;
var init_getLoomToken2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/getLoomToken.ts"() {
    "use strict";
    init_core();
    init_src();
    Response5 = schemas_exports.string();
    Error88 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.getLoomToken.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/startCreateGuide.ts
var startCreateGuide_exports2 = {};
__export(startCreateGuide_exports2, {
  Error: () => Error89
});
var Error89;
var init_startCreateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/startCreateGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error89 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.startCreateGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishCreateGuide.ts
var finishCreateGuide_exports2 = {};
__export(finishCreateGuide_exports2, {
  Error: () => Error90,
  Response: () => Response6
});
var Response6, Error90;
var init_finishCreateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishCreateGuide.ts"() {
    "use strict";
    init_core();
    init_src();
    Response6 = schemas_exports.boolean();
    Error90 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishCreateGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts
var initiateCreateGuide_exports2 = {};
__export(initiateCreateGuide_exports2, {
  Error: () => Error91
});
var Error91;
var init_initiateCreateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateCreateGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error91 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateCreateGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/initiateCreateVideoGuide.ts
var initiateCreateVideoGuide_exports2 = {};
__export(initiateCreateVideoGuide_exports2, {
  Error: () => Error92
});
var Error92;
var init_initiateCreateVideoGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/initiateCreateVideoGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error92 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.initiateCreateVideoGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/uploadImage.ts
var uploadImage_exports2 = {};
__export(uploadImage_exports2, {
  Error: () => Error93
});
var Error93;
var init_uploadImage2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/uploadImage.ts"() {
    "use strict";
    init_src();
    init_core();
    Error93 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.uploadImage.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts
var uploadVideoChunk_exports2 = {};
__export(uploadVideoChunk_exports2, {
  Error: () => Error94
});
var Error94;
var init_uploadVideoChunk2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/uploadVideoChunk.ts"() {
    "use strict";
    init_src();
    init_core();
    Error94 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.uploadVideoChunk.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/compileVideo.ts
var compileVideo_exports2 = {};
__export(compileVideo_exports2, {
  Error: () => Error95
});
var Error95;
var init_compileVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/compileVideo.ts"() {
    "use strict";
    init_src();
    init_core();
    Error95 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.compileVideo.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateGuideData.ts
var updateGuideData_exports2 = {};
__export(updateGuideData_exports2, {
  Error: () => Error96
});
var Error96;
var init_updateGuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error96 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateGuideData.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateVideoEdits.ts
var updateVideoEdits_exports2 = {};
__export(updateVideoEdits_exports2, {
  Error: () => Error97
});
var Error97;
var init_updateVideoEdits2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateVideoEdits.ts"() {
    "use strict";
    init_src();
    init_core();
    Error97 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateVideoEdits.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.updateVideoEdits.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts
var finishUpdateGuideData_exports2 = {};
__export(finishUpdateGuideData_exports2, {
  Error: () => Error98,
  Response: () => Response7
});
var Response7, Error98;
var init_finishUpdateGuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUpdateGuideData.ts"() {
    "use strict";
    init_core();
    init_src();
    Response7 = schemas_exports.boolean();
    Error98 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUpdateGuideData.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/createGuide.ts
var createGuide_exports2 = {};
__export(createGuide_exports2, {
  Error: () => Error99
});
var Error99;
var init_createGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/createGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error99 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.createGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.createGuide.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts
var createEmptyTextGuide_exports2 = {};
__export(createEmptyTextGuide_exports2, {
  Error: () => Error100
});
var Error100;
var init_createEmptyTextGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/createEmptyTextGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error100 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.createEmptyTextGuide.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/updateGuidePreview.ts
var updateGuidePreview_exports2 = {};
__export(updateGuidePreview_exports2, {
  Error: () => Error101
});
var Error101;
var init_updateGuidePreview2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/updateGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error101 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.updateGuidePreview.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/pinGuide.ts
var pinGuide_exports2 = {};
__export(pinGuide_exports2, {
  Error: () => Error102
});
var Error102;
var init_pinGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/pinGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error102 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.pinGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.pinGuide.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/moveGuide.ts
var moveGuide_exports2 = {};
__export(moveGuide_exports2, {
  Error: () => Error103
});
var Error103;
var init_moveGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/moveGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error103 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.moveGuide.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideMutations.moveGuide.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/convertToGif.ts
var convertToGif_exports2 = {};
__export(convertToGif_exports2, {
  Response: () => Response8
});
var Response8;
var init_convertToGif2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/convertToGif.ts"() {
    "use strict";
    init_core();
    Response8 = schemas_exports.string();
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/finishUploadVideoGuide.ts
var finishUploadVideoGuide_exports2 = {};
__export(finishUploadVideoGuide_exports2, {
  Error: () => Error104,
  Response: () => Response9
});
var Response9, Error104;
var init_finishUploadVideoGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/finishUploadVideoGuide.ts"() {
    "use strict";
    init_core();
    init_src();
    Response9 = schemas_exports.boolean();
    Error104 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.finishUploadVideoGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/duplicateGuide.ts
var duplicateGuide_exports2 = {};
__export(duplicateGuide_exports2, {
  Error: () => Error105
});
var Error105;
var init_duplicateGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/duplicateGuide.ts"() {
    "use strict";
    init_src();
    init_core();
    Error105 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideMutations.duplicateGuide.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishCreateGuideRequest.ts
var FinishCreateGuideRequest;
var init_FinishCreateGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishCreateGuideRequest.ts"() {
    "use strict";
    init_core();
    FinishCreateGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      tourSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStep)
      ),
      docSteps: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DocStep)
      ),
      language: schemas_exports.string().optional(),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/CreateEmptyTextGuideRequest.ts
var CreateEmptyTextGuideRequest;
var init_CreateEmptyTextGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/CreateEmptyTextGuideRequest.ts"() {
    "use strict";
    init_core();
    CreateEmptyTextGuideRequest = schemas_exports.object({
      parentId: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/PinGuideRequest.ts
var PinGuideRequest;
var init_PinGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/PinGuideRequest.ts"() {
    "use strict";
    init_core();
    PinGuideRequest = schemas_exports.object({
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      isPinned: schemas_exports.boolean()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/DeleteGuideRequest.ts
var DeleteGuideRequest;
var init_DeleteGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/DeleteGuideRequest.ts"() {
    "use strict";
    init_core();
    DeleteGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/ReorderGuideRequest.ts
var ReorderGuideRequest;
var init_ReorderGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/ReorderGuideRequest.ts"() {
    "use strict";
    init_core();
    ReorderGuideRequest = schemas_exports.object({
      succeedingGuide: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      precedingGuide: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/ExportGuideRequest.ts
var ExportGuideRequest;
var init_ExportGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/ExportGuideRequest.ts"() {
    "use strict";
    init_core();
    ExportGuideRequest = schemas_exports.object({
      guide: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Guide)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/ConvertToGif.ts
var ConvertToGif;
var init_ConvertToGif = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/ConvertToGif.ts"() {
    "use strict";
    init_core();
    ConvertToGif = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      length: schemas_exports.number(),
      background: schemas_exports.boolean(),
      start: schemas_exports.number().optional(),
      end: schemas_exports.number().optional(),
      color: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadVideo.ts
var FinishUploadVideo;
var init_FinishUploadVideo = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/FinishUploadVideo.ts"() {
    "use strict";
    init_core();
    FinishUploadVideo = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/DuplicateGuideRequest.ts
var DuplicateGuideRequest;
var init_DuplicateGuideRequest = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/DuplicateGuideRequest.ts"() {
    "use strict";
    init_core();
    DuplicateGuideRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/requests/index.ts
var init_requests10 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/requests/index.ts"() {
    "use strict";
    init_FinishCreateGuideRequest();
    init_CreateEmptyTextGuideRequest();
    init_PinGuideRequest();
    init_DeleteGuideRequest();
    init_ReorderGuideRequest();
    init_ExportGuideRequest();
    init_ConvertToGif();
    init_FinishUploadVideo();
    init_DuplicateGuideRequest();
  }
});

// src/serialization/resources/guides/resources/guideMutations/client/index.ts
var init_client17 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/client/index.ts"() {
    "use strict";
    init_generateVideo2();
    init_generateEditedVideo2();
    init_generateBookendsVideo2();
    init_enhance2();
    init_enhanceVideoTranscript2();
    init_getLoomToken2();
    init_startCreateGuide2();
    init_finishCreateGuide2();
    init_initiateCreateGuide2();
    init_initiateCreateVideoGuide2();
    init_uploadImage2();
    init_uploadVideoChunk2();
    init_compileVideo2();
    init_updateGuideData2();
    init_updateVideoEdits2();
    init_finishUpdateGuideData2();
    init_createGuide2();
    init_createEmptyTextGuide2();
    init_updateGuidePreview2();
    init_pinGuide2();
    init_moveGuide2();
    init_convertToGif2();
    init_finishUploadVideoGuide2();
    init_duplicateGuide2();
    init_requests10();
  }
});

// src/serialization/resources/guides/resources/guideMutations/index.ts
var guideMutations_exports2 = {};
__export(guideMutations_exports2, {
  CompileVideoRequest: () => CompileVideoRequest,
  CompileVideoResponse: () => CompileVideoResponse,
  ConvertToGif: () => ConvertToGif,
  CreateEmptyTextGuideRequest: () => CreateEmptyTextGuideRequest,
  DeleteGuideRequest: () => DeleteGuideRequest,
  DuplicateGuideRequest: () => DuplicateGuideRequest,
  ExportGuideRequest: () => ExportGuideRequest,
  ExportGuideResponse: () => ExportGuideResponse,
  FinishCreateGuideRequest: () => FinishCreateGuideRequest,
  FinishUploadVideo: () => FinishUploadVideo,
  GenerateBookendsVideoRequest: () => GenerateBookendsVideoRequest,
  GenerateEditedVideoRequest: () => GenerateEditedVideoRequest,
  GenerateVideoRequest: () => GenerateVideoRequest,
  InitiateCreateGuideRequest: () => InitiateCreateGuideRequest,
  InitiateCreateVideoGuideResponse: () => InitiateCreateVideoGuideResponse,
  MoveGuideRequest: () => MoveGuideRequest,
  PinGuideRequest: () => PinGuideRequest,
  PlainDocRequest: () => PlainDocRequest,
  ReorderGuideRequest: () => ReorderGuideRequest,
  UpdateVideoEditsRequest: () => UpdateVideoEditsRequest,
  UploadChunkRequest: () => UploadChunkRequest,
  compileVideo: () => compileVideo_exports2,
  convertToGif: () => convertToGif_exports2,
  createEmptyTextGuide: () => createEmptyTextGuide_exports2,
  createGuide: () => createGuide_exports2,
  duplicateGuide: () => duplicateGuide_exports2,
  enhance: () => enhance_exports2,
  enhanceVideoTranscript: () => enhanceVideoTranscript_exports2,
  finishCreateGuide: () => finishCreateGuide_exports2,
  finishUpdateGuideData: () => finishUpdateGuideData_exports2,
  finishUploadVideoGuide: () => finishUploadVideoGuide_exports2,
  generateBookendsVideo: () => generateBookendsVideo_exports2,
  generateEditedVideo: () => generateEditedVideo_exports2,
  generateVideo: () => generateVideo_exports2,
  getLoomToken: () => getLoomToken_exports2,
  initiateCreateGuide: () => initiateCreateGuide_exports2,
  initiateCreateVideoGuide: () => initiateCreateVideoGuide_exports2,
  moveGuide: () => moveGuide_exports2,
  pinGuide: () => pinGuide_exports2,
  startCreateGuide: () => startCreateGuide_exports2,
  updateGuideData: () => updateGuideData_exports2,
  updateGuidePreview: () => updateGuidePreview_exports2,
  updateVideoEdits: () => updateVideoEdits_exports2,
  uploadImage: () => uploadImage_exports2,
  uploadVideoChunk: () => uploadVideoChunk_exports2
});
var init_guideMutations2 = __esm({
  "src/serialization/resources/guides/resources/guideMutations/index.ts"() {
    "use strict";
    init_types16();
    init_client17();
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoObject.ts
var VideoObject;
var init_VideoObject2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoObject.ts"() {
    "use strict";
    init_core();
    VideoObject = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional(),
      src: schemas_exports.string(),
      metadata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoMetadata),
      format: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).VideoFormat).optional(),
      key: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoRecordingType.ts
var VideoRecordingType2;
var init_VideoRecordingType2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoRecordingType.ts"() {
    "use strict";
    init_core();
    VideoRecordingType2 = schemas_exports.enum_(["default", "loom"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PublishedVideoType.ts
var PublishedVideoType2;
var init_PublishedVideoType2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PublishedVideoType.ts"() {
    "use strict";
    init_core();
    PublishedVideoType2 = schemas_exports.enum_(["ai", "original", "none"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoMetadata.ts
var VideoMetadata;
var init_VideoMetadata2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoMetadata.ts"() {
    "use strict";
    init_core();
    VideoMetadata = schemas_exports.object({
      recorderType: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoRecordingType).optional(),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      generatedVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GeneratedVideo).optional(),
      editedVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.EditedVideo).optional(),
      decoratedAiVideo: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.EditedVideo).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts
var PresignedUrlsForGuide;
var init_PresignedUrlsForGuide2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsForGuide.ts"() {
    "use strict";
    init_core();
    PresignedUrlsForGuide = schemas_exports.object({
      guide: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl),
      video: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl).optional(),
      images: schemas_exports.list(schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PresignedUrl)).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts
var PresignedUrlsResponse;
var init_PresignedUrlsResponse2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PresignedUrlsResponse.ts"() {
    "use strict";
    init_core();
    PresignedUrlsResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      presignedUrls: schemas_exports.property(
        "presigned_urls",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PresignedUrlsForGuide)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Guide.ts
var Guide;
var init_Guide2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Guide.ts"() {
    "use strict";
    init_core();
    Guide = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      guidePreview: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview),
      guideData: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideData)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideHeader.ts
var GuideHeader;
var init_GuideHeader2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideHeader.ts"() {
    "use strict";
    init_core();
    GuideHeader = schemas_exports.object({
      name: schemas_exports.string(),
      description: schemas_exports.string().optional(),
      published: schemas_exports.boolean().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuidePreview.ts
var GuidePreview;
var init_GuidePreview2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuidePreview.ts"() {
    "use strict";
    init_core();
    GuidePreview = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      header: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuideHeader),
      sequenceNumber: schemas_exports.property("sequence_number", schemas_exports.number().optional()),
      parentId: schemas_exports.property(
        "parent_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id).optional()
      ),
      generatedVideoExists: schemas_exports.property(
        "generated_video_exists",
        schemas_exports.boolean().optional()
      ),
      loadingGeneratedVideo: schemas_exports.property(
        "loading_generated_video",
        schemas_exports.boolean().optional()
      ),
      hideArticle: schemas_exports.property("hide_article", schemas_exports.boolean().optional()),
      publishedVideo: schemas_exports.property(
        "published_video",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PublishedVideoType).optional()
      ),
      ogVideoClips: schemas_exports.property(
        "og_video_clips",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoClip)).optional()
      ),
      editedVideoExists: schemas_exports.property("edited_video_exists", schemas_exports.boolean().optional()),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      deleted: schemas_exports.boolean().optional(),
      introCover: schemas_exports.property("intro_cover", schemas_exports.boolean().optional()),
      mainBackground: schemas_exports.property("main_background", schemas_exports.boolean().optional()),
      outroCover: schemas_exports.property("outro_cover", schemas_exports.boolean().optional()),
      decoratedAiVideoExists: schemas_exports.property(
        "decorated_ai_video_exists",
        schemas_exports.boolean().optional()
      ),
      isPinned: schemas_exports.boolean().optional(),
      version: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Version).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GuideData.ts
var GuideData;
var init_GuideData2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GuideData.ts"() {
    "use strict";
    init_core();
    GuideData = schemas_exports.object({
      tourEnabled: schemas_exports.boolean().optional(),
      video: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VideoObject),
      plainDoc: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      tour: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStep)
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/PlainDoc.ts
var PlainDoc;
var init_PlainDoc2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/PlainDoc.ts"() {
    "use strict";
    init_core();
    PlainDoc = schemas_exports.object({
      version: schemas_exports.string(),
      data: schemas_exports.unknown()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/DocStep.ts
var DocStep;
var init_DocStep2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/DocStep.ts"() {
    "use strict";
    init_core();
    DocStep = schemas_exports.object({
      stepId: schemas_exports.property(
        "step_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      text: schemas_exports.string(),
      timestamp: schemas_exports.number(),
      s3ObjectId: schemas_exports.string(),
      zoomCenter: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Coordinates).optional(),
      naturalDimensions: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Coordinates).optional(),
      domElementData: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData).optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Coordinates.ts
var Coordinates;
var init_Coordinates2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Coordinates.ts"() {
    "use strict";
    init_core();
    Coordinates = schemas_exports.object({
      x: schemas_exports.number(),
      y: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/AutoProgressable.ts
var AutoProgressable2;
var init_AutoProgressable2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/AutoProgressable.ts"() {
    "use strict";
    init_core();
    AutoProgressable2 = schemas_exports.enum_(["auto", "newButton"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TourStep.ts
var TourStep;
var init_TourStep2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TourStep.ts"() {
    "use strict";
    init_core();
    TourStep = schemas_exports.object({
      stepId: schemas_exports.property(
        "step_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
      ),
      domElementData: schemas_exports.lazyObject(
        async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData
      ),
      metadata: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.TourStepMetadata)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/TourStepMetadata.ts
var TourStepMetadata;
var init_TourStepMetadata2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/TourStepMetadata.ts"() {
    "use strict";
    init_core();
    TourStepMetadata = schemas_exports.object({
      title: schemas_exports.string().optional(),
      text: schemas_exports.string(),
      ancestor: schemas_exports.number(),
      skippable: schemas_exports.boolean(),
      autoProgressable: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.AutoProgressable),
      parents: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.DomElementData)
      ),
      customSelector: schemas_exports.property(
        "custom_selector",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.CustomSelector).optional()
      )
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/CustomSelector.ts
var CustomSelector;
var init_CustomSelector2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/CustomSelector.ts"() {
    "use strict";
    init_core();
    CustomSelector = schemas_exports.object({
      name: schemas_exports.string(),
      value: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/DomElementData.ts
var DomElementData;
var init_DomElementData2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/DomElementData.ts"() {
    "use strict";
    init_core();
    DomElementData = schemas_exports.object({
      id: schemas_exports.string(),
      textContent: schemas_exports.string(),
      className: schemas_exports.string(),
      tagName: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/GeneratedVideo.ts
var GeneratedVideo;
var init_GeneratedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/GeneratedVideo.ts"() {
    "use strict";
    init_core();
    GeneratedVideo = schemas_exports.object({
      src: schemas_exports.string().optional(),
      transcript: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.PlainDoc),
      subtitles: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/EditedVideo.ts
var EditedVideo;
var init_EditedVideo2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/EditedVideo.ts"() {
    "use strict";
    init_core();
    EditedVideo = schemas_exports.object({
      src: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VideoClip.ts
var VideoClip;
var init_VideoClip2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VideoClip.ts"() {
    "use strict";
    init_core();
    VideoClip = schemas_exports.object({
      startTime: schemas_exports.number(),
      endTime: schemas_exports.number()
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/Voice.ts
var Voice;
var init_Voice2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/Voice.ts"() {
    "use strict";
    init_core();
    Voice = schemas_exports.object({
      language: schemas_exports.string().optional(),
      code: schemas_exports.string(),
      engine: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.VoiceEngine)
    });
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/VoiceEngine.ts
var VoiceEngine2;
var init_VoiceEngine2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/VoiceEngine.ts"() {
    "use strict";
    init_core();
    VoiceEngine2 = schemas_exports.enum_(["google", "play"]);
  }
});

// src/serialization/resources/guides/resources/guideTypes/types/index.ts
var init_types17 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/types/index.ts"() {
    "use strict";
    init_VideoObject2();
    init_VideoRecordingType2();
    init_PublishedVideoType2();
    init_VideoMetadata2();
    init_PresignedUrlsForGuide2();
    init_PresignedUrlsResponse2();
    init_Guide2();
    init_GuideHeader2();
    init_GuidePreview2();
    init_GuideData2();
    init_PlainDoc2();
    init_DocStep2();
    init_Coordinates2();
    init_AutoProgressable2();
    init_TourStep2();
    init_TourStepMetadata2();
    init_CustomSelector2();
    init_DomElementData2();
    init_GeneratedVideo2();
    init_EditedVideo2();
    init_VideoClip2();
    init_Voice2();
    init_VoiceEngine2();
  }
});

// src/serialization/resources/guides/resources/guideTypes/index.ts
var guideTypes_exports2 = {};
__export(guideTypes_exports2, {
  AutoProgressable: () => AutoProgressable2,
  Coordinates: () => Coordinates,
  CustomSelector: () => CustomSelector,
  DocStep: () => DocStep,
  DomElementData: () => DomElementData,
  EditedVideo: () => EditedVideo,
  GeneratedVideo: () => GeneratedVideo,
  Guide: () => Guide,
  GuideData: () => GuideData,
  GuideHeader: () => GuideHeader,
  GuidePreview: () => GuidePreview,
  PlainDoc: () => PlainDoc,
  PresignedUrlsForGuide: () => PresignedUrlsForGuide,
  PresignedUrlsResponse: () => PresignedUrlsResponse,
  PublishedVideoType: () => PublishedVideoType2,
  TourStep: () => TourStep,
  TourStepMetadata: () => TourStepMetadata,
  VideoClip: () => VideoClip,
  VideoMetadata: () => VideoMetadata,
  VideoObject: () => VideoObject,
  VideoRecordingType: () => VideoRecordingType2,
  Voice: () => Voice,
  VoiceEngine: () => VoiceEngine2
});
var init_guideTypes2 = __esm({
  "src/serialization/resources/guides/resources/guideTypes/index.ts"() {
    "use strict";
    init_types17();
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/search.ts
var search_exports3 = {};
__export(search_exports3, {
  Error: () => Error106,
  Response: () => Response10
});
var Response10, Error106;
var init_search3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/search.ts"() {
    "use strict";
    init_src();
    init_core();
    Response10 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error106 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.search.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports3 = {};
__export(getGuidePreviews_exports3, {
  Error: () => Error107,
  Response: () => Response11
});
var Response11, Error107;
var init_getGuidePreviews3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response11 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error107 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuidePreviews.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports3 = {};
__export(getAllGuidePreviews_exports3, {
  Error: () => Error108,
  Response: () => Response12
});
var Response12, Error108;
var init_getAllGuidePreviews3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response12 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview)
    );
    Error108 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getAllGuidePreviews.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuideData.ts
var getGuideData_exports3 = {};
__export(getGuideData_exports3, {
  Error: () => Error109
});
var Error109;
var init_getGuideData3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error109 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuideData.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getVideoEdits.ts
var getVideoEdits_exports3 = {};
__export(getVideoEdits_exports3, {
  Error: () => Error110
});
var Error110;
var init_getVideoEdits3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getVideoEdits.ts"() {
    "use strict";
    init_src();
    init_core();
    Error110 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getVideoEdits.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideQueries.getVideoEdits.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/getGuidePreview.ts
var getGuidePreview_exports3 = {};
__export(getGuidePreview_exports3, {
  Error: () => Error111
});
var Error111;
var init_getGuidePreview3 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error111 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.guides.guideQueries.getGuidePreview.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/SearchRequest.ts
var SearchRequest;
var init_SearchRequest = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/SearchRequest.ts"() {
    "use strict";
    init_core();
    SearchRequest = schemas_exports.object({
      text: schemas_exports.string()
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/GetGuideDataRequest.ts
var GetGuideDataRequest;
var init_GetGuideDataRequest = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/GetGuideDataRequest.ts"() {
    "use strict";
    init_core();
    GetGuideDataRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/GetVideoEditsRequest.ts
var GetVideoEditsRequest;
var init_GetVideoEditsRequest = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/GetVideoEditsRequest.ts"() {
    "use strict";
    init_core();
    GetVideoEditsRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/GetGuidePreviewRequest.ts
var GetGuidePreviewRequest;
var init_GetGuidePreviewRequest = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/GetGuidePreviewRequest.ts"() {
    "use strict";
    init_core();
    GetGuidePreviewRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/requests/index.ts
var init_requests11 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/requests/index.ts"() {
    "use strict";
    init_SearchRequest();
    init_GetGuideDataRequest();
    init_GetVideoEditsRequest();
    init_GetGuidePreviewRequest();
  }
});

// src/serialization/resources/guides/resources/guideQueries/client/index.ts
var init_client18 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/client/index.ts"() {
    "use strict";
    init_search3();
    init_getGuidePreviews3();
    init_getAllGuidePreviews3();
    init_getGuideData3();
    init_getVideoEdits3();
    init_getGuidePreview3();
    init_requests11();
  }
});

// src/serialization/resources/guides/resources/guideQueries/index.ts
var guideQueries_exports2 = {};
__export(guideQueries_exports2, {
  GetGuideDataRequest: () => GetGuideDataRequest,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest,
  GetVideoEditsRequest: () => GetVideoEditsRequest,
  SearchRequest: () => SearchRequest,
  getAllGuidePreviews: () => getAllGuidePreviews_exports3,
  getGuideData: () => getGuideData_exports3,
  getGuidePreview: () => getGuidePreview_exports3,
  getGuidePreviews: () => getGuidePreviews_exports3,
  getVideoEdits: () => getVideoEdits_exports3,
  search: () => search_exports3
});
var init_guideQueries2 = __esm({
  "src/serialization/resources/guides/resources/guideQueries/index.ts"() {
    "use strict";
    init_client18();
  }
});

// src/serialization/resources/guides/resources/index.ts
var init_resources6 = __esm({
  "src/serialization/resources/guides/resources/index.ts"() {
    "use strict";
    init_guideMutations2();
    init_types16();
    init_guideTypes2();
    init_types17();
    init_guideQueries2();
    init_requests10();
    init_requests11();
  }
});

// src/serialization/resources/guides/index.ts
var guides_exports2 = {};
__export(guides_exports2, {
  AutoProgressable: () => AutoProgressable2,
  CompileVideoRequest: () => CompileVideoRequest,
  CompileVideoResponse: () => CompileVideoResponse,
  ConvertToGif: () => ConvertToGif,
  Coordinates: () => Coordinates,
  CreateEmptyTextGuideRequest: () => CreateEmptyTextGuideRequest,
  CustomSelector: () => CustomSelector,
  DeleteGuideRequest: () => DeleteGuideRequest,
  DocStep: () => DocStep,
  DomElementData: () => DomElementData,
  DuplicateGuideRequest: () => DuplicateGuideRequest,
  EditedVideo: () => EditedVideo,
  ExportGuideRequest: () => ExportGuideRequest,
  ExportGuideResponse: () => ExportGuideResponse,
  FinishCreateGuideRequest: () => FinishCreateGuideRequest,
  FinishUploadVideo: () => FinishUploadVideo,
  GenerateBookendsVideoRequest: () => GenerateBookendsVideoRequest,
  GenerateEditedVideoRequest: () => GenerateEditedVideoRequest,
  GenerateVideoRequest: () => GenerateVideoRequest,
  GeneratedVideo: () => GeneratedVideo,
  GetGuideDataRequest: () => GetGuideDataRequest,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest,
  GetVideoEditsRequest: () => GetVideoEditsRequest,
  Guide: () => Guide,
  GuideData: () => GuideData,
  GuideHeader: () => GuideHeader,
  GuidePreview: () => GuidePreview,
  InitiateCreateGuideRequest: () => InitiateCreateGuideRequest,
  InitiateCreateVideoGuideResponse: () => InitiateCreateVideoGuideResponse,
  MoveGuideRequest: () => MoveGuideRequest,
  PinGuideRequest: () => PinGuideRequest,
  PlainDoc: () => PlainDoc,
  PlainDocRequest: () => PlainDocRequest,
  PresignedUrlsForGuide: () => PresignedUrlsForGuide,
  PresignedUrlsResponse: () => PresignedUrlsResponse,
  PublishedVideoType: () => PublishedVideoType2,
  ReorderGuideRequest: () => ReorderGuideRequest,
  SearchRequest: () => SearchRequest,
  TourStep: () => TourStep,
  TourStepMetadata: () => TourStepMetadata,
  UpdateVideoEditsRequest: () => UpdateVideoEditsRequest,
  UploadChunkRequest: () => UploadChunkRequest,
  VideoClip: () => VideoClip,
  VideoMetadata: () => VideoMetadata,
  VideoObject: () => VideoObject,
  VideoRecordingType: () => VideoRecordingType2,
  Voice: () => Voice,
  VoiceEngine: () => VoiceEngine2,
  guideMutations: () => guideMutations_exports2,
  guideQueries: () => guideQueries_exports2,
  guideTypes: () => guideTypes_exports2
});
var init_guides2 = __esm({
  "src/serialization/resources/guides/index.ts"() {
    "use strict";
    init_resources6();
  }
});

// src/serialization/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts
var InvalidSessionErrorBody;
var init_InvalidSessionErrorBody2 = __esm({
  "src/serialization/resources/helpcenterQueries/types/InvalidSessionErrorBody.ts"() {
    "use strict";
    init_core();
    InvalidSessionErrorBody = schemas_exports.object({
      redirectUrl: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenterQueries/types/index.ts
var init_types18 = __esm({
  "src/serialization/resources/helpcenterQueries/types/index.ts"() {
    "use strict";
    init_InvalidSessionErrorBody2();
  }
});

// src/serialization/resources/helpcenterQueries/client/validateToken.ts
var validateToken_exports2 = {};
__export(validateToken_exports2, {
  Error: () => Error112,
  Response: () => Response13
});
var Response13, Error112;
var init_validateToken2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/validateToken.ts"() {
    "use strict";
    init_core();
    init_src();
    Response13 = schemas_exports.string();
    Error112 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.helpcenterQueries.validateToken.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getOrganization.ts
var getOrganization_exports3 = {};
__export(getOrganization_exports3, {
  Error: () => Error113
});
var Error113;
var init_getOrganization3 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error113 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getOrganization.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/search.ts
var search_exports4 = {};
__export(search_exports4, {
  Error: () => Error114,
  Response: () => Response14
});
var Response14, Error114;
var init_search4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/search.ts"() {
    "use strict";
    init_src();
    init_core();
    Response14 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error114 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.search.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuidePreviews.ts
var getGuidePreviews_exports4 = {};
__export(getGuidePreviews_exports4, {
  Error: () => Error115,
  Response: () => Response15
});
var Response15, Error115;
var init_getGuidePreviews4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response15 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error115 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuidePreviews.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllGuidePreviews.ts
var getAllGuidePreviews_exports4 = {};
__export(getAllGuidePreviews_exports4, {
  Error: () => Error116,
  Response: () => Response16
});
var Response16, Error116;
var init_getAllGuidePreviews4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllGuidePreviews.ts"() {
    "use strict";
    init_src();
    init_core();
    Response16 = schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.GuidePreview));
    Error116 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllGuidePreviews.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuideData.ts
var getGuideData_exports4 = {};
__export(getGuideData_exports4, {
  Error: () => Error117
});
var Error117;
var init_getGuideData4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuideData.ts"() {
    "use strict";
    init_src();
    init_core();
    Error117 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuideData.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getGuidePreview.ts
var getGuidePreview_exports4 = {};
__export(getGuidePreview_exports4, {
  Error: () => Error118
});
var Error118;
var init_getGuidePreview4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getGuidePreview.ts"() {
    "use strict";
    init_src();
    init_core();
    Error118 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      }),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.invalidSessionError(value.content);
          case "QueryFailedError":
            return api_exports.helpcenterQueries.getGuidePreview.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getVideoEdits.ts
var getVideoEdits_exports4 = {};
__export(getVideoEdits_exports4, {
  Error: () => Error119
});
var Error119;
var init_getVideoEdits4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getVideoEdits.ts"() {
    "use strict";
    init_src();
    init_core();
    Error119 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({}),
      QueryFailedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.helpcenterQueries.getVideoEdits.Error.unauthorizedError();
          case "QueryFailedError":
            return api_exports.helpcenterQueries.getVideoEdits.Error.queryFailedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getCollections.ts
var getCollections_exports4 = {};
__export(getCollections_exports4, {
  Error: () => Error120
});
var Error120;
var init_getCollections4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Error120 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getCollections.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllChildren.ts
var getAllChildren_exports4 = {};
__export(getAllChildren_exports4, {
  Error: () => Error121
});
var Error121;
var init_getAllChildren4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllChildren.ts"() {
    "use strict";
    init_src();
    init_core();
    Error121 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllChildren.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getAllCollections.ts
var getAllCollections_exports4 = {};
__export(getAllCollections_exports4, {
  Error: () => Error122,
  Response: () => Response17
});
var Response17, Error122;
var init_getAllCollections4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getAllCollections.ts"() {
    "use strict";
    init_src();
    init_core();
    Response17 = schemas_exports.list(
      schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).collections.Collection)
    );
    Error122 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getAllCollections.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/getPath.ts
var getPath_exports4 = {};
__export(getPath_exports4, {
  Error: () => Error123
});
var Error123;
var init_getPath4 = __esm({
  "src/serialization/resources/helpcenterQueries/client/getPath.ts"() {
    "use strict";
    init_src();
    init_core();
    Error123 = schemas_exports.union("error", {
      InvalidSessionError: schemas_exports.object({
        content: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).InvalidSessionErrorBody)
      })
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "InvalidSessionError":
            return api_exports.helpcenterQueries.getPath.Error.invalidSessionError(value.content);
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/SearchRequest.ts
var SearchRequest2;
var init_SearchRequest2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/SearchRequest.ts"() {
    "use strict";
    init_core();
    SearchRequest2 = schemas_exports.object({
      text: schemas_exports.string()
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/GetGuideDataRequest.ts
var GetGuideDataRequest2;
var init_GetGuideDataRequest2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/GetGuideDataRequest.ts"() {
    "use strict";
    init_core();
    GetGuideDataRequest2 = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/GetGuidePreviewRequest.ts
var GetGuidePreviewRequest2;
var init_GetGuidePreviewRequest2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/GetGuidePreviewRequest.ts"() {
    "use strict";
    init_core();
    GetGuidePreviewRequest2 = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/GetVideoEditsRequest.ts
var GetVideoEditsRequest2;
var init_GetVideoEditsRequest2 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/GetVideoEditsRequest.ts"() {
    "use strict";
    init_core();
    GetVideoEditsRequest2 = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/helpcenterQueries/client/requests/index.ts
var init_requests12 = __esm({
  "src/serialization/resources/helpcenterQueries/client/requests/index.ts"() {
    "use strict";
    init_SearchRequest2();
    init_GetGuideDataRequest2();
    init_GetGuidePreviewRequest2();
    init_GetVideoEditsRequest2();
  }
});

// src/serialization/resources/helpcenterQueries/client/index.ts
var init_client19 = __esm({
  "src/serialization/resources/helpcenterQueries/client/index.ts"() {
    "use strict";
    init_validateToken2();
    init_getOrganization3();
    init_search4();
    init_getGuidePreviews4();
    init_getAllGuidePreviews4();
    init_getGuideData4();
    init_getGuidePreview4();
    init_getVideoEdits4();
    init_getCollections4();
    init_getAllChildren4();
    init_getAllCollections4();
    init_getPath4();
    init_requests12();
  }
});

// src/serialization/resources/helpcenterQueries/index.ts
var helpcenterQueries_exports2 = {};
__export(helpcenterQueries_exports2, {
  GetGuideDataRequest: () => GetGuideDataRequest2,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest2,
  GetVideoEditsRequest: () => GetVideoEditsRequest2,
  InvalidSessionErrorBody: () => InvalidSessionErrorBody,
  SearchRequest: () => SearchRequest2,
  getAllChildren: () => getAllChildren_exports4,
  getAllCollections: () => getAllCollections_exports4,
  getAllGuidePreviews: () => getAllGuidePreviews_exports4,
  getCollections: () => getCollections_exports4,
  getGuideData: () => getGuideData_exports4,
  getGuidePreview: () => getGuidePreview_exports4,
  getGuidePreviews: () => getGuidePreviews_exports4,
  getOrganization: () => getOrganization_exports3,
  getPath: () => getPath_exports4,
  getVideoEdits: () => getVideoEdits_exports4,
  search: () => search_exports4,
  validateToken: () => validateToken_exports2
});
var init_helpcenterQueries2 = __esm({
  "src/serialization/resources/helpcenterQueries/index.ts"() {
    "use strict";
    init_types18();
    init_client19();
  }
});

// src/serialization/resources/organization/types/User.ts
var User;
var init_User2 = __esm({
  "src/serialization/resources/organization/types/User.ts"() {
    "use strict";
    init_core();
    User = schemas_exports.object({
      sub: schemas_exports.string(),
      givenName: schemas_exports.property("given_name", schemas_exports.string().optional()),
      familyName: schemas_exports.property("family_name", schemas_exports.string().optional()),
      nickname: schemas_exports.string().optional(),
      name: schemas_exports.string().optional(),
      email: schemas_exports.string(),
      emailVerified: schemas_exports.property("email_verified", schemas_exports.boolean()),
      locale: schemas_exports.string().optional(),
      picture: schemas_exports.string().optional(),
      updatedAt: schemas_exports.property("updated_at", schemas_exports.string().optional())
    });
  }
});

// src/serialization/resources/organization/types/OrganizationInput.ts
var OrganizationInput;
var init_OrganizationInput2 = __esm({
  "src/serialization/resources/organization/types/OrganizationInput.ts"() {
    "use strict";
    init_core();
    OrganizationInput = schemas_exports.object({
      name: schemas_exports.string(),
      brandColor: schemas_exports.property("brand_color", schemas_exports.string().optional()),
      tourEnabled: schemas_exports.property("tour_enabled", schemas_exports.boolean().optional())
    });
  }
});

// src/serialization/resources/organization/types/Organization.ts
var Organization;
var init_Organization2 = __esm({
  "src/serialization/resources/organization/types/Organization.ts"() {
    "use strict";
    init_core();
    Organization = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id),
      domain: schemas_exports.string(),
      customLogin: schemas_exports.property("custom_login", schemas_exports.boolean().optional())
    }).extend(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrganizationInput));
  }
});

// src/serialization/resources/organization/types/GetAllOrganizationsResponse.ts
var GetAllOrganizationsResponse;
var init_GetAllOrganizationsResponse2 = __esm({
  "src/serialization/resources/organization/types/GetAllOrganizationsResponse.ts"() {
    "use strict";
    init_core();
    GetAllOrganizationsResponse = schemas_exports.object({
      organizations: schemas_exports.list(
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Organization)
      )
    });
  }
});

// src/serialization/resources/organization/types/index.ts
var init_types19 = __esm({
  "src/serialization/resources/organization/types/index.ts"() {
    "use strict";
    init_User2();
    init_OrganizationInput2();
    init_Organization2();
    init_GetAllOrganizationsResponse2();
  }
});

// src/serialization/resources/organization/client/getOrganization.ts
var getOrganization_exports4 = {};
__export(getOrganization_exports4, {
  Error: () => Error124
});
var Error124;
var init_getOrganization4 = __esm({
  "src/serialization/resources/organization/client/getOrganization.ts"() {
    "use strict";
    init_src();
    init_core();
    Error124 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organization.getOrganization.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organization/client/getHostname.ts
var getHostname_exports2 = {};
__export(getHostname_exports2, {
  Error: () => Error125,
  Response: () => Response18
});
var Response18, Error125;
var init_getHostname2 = __esm({
  "src/serialization/resources/organization/client/getHostname.ts"() {
    "use strict";
    init_core();
    init_src();
    Response18 = schemas_exports.string();
    Error125 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organization.getHostname.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organization/client/getOrganizationFromId.ts
var getOrganizationFromId_exports2 = {};
__export(getOrganizationFromId_exports2, {
  Error: () => Error126
});
var Error126;
var init_getOrganizationFromId2 = __esm({
  "src/serialization/resources/organization/client/getOrganizationFromId.ts"() {
    "use strict";
    init_src();
    init_core();
    Error126 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organization.getOrganizationFromId.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organization/client/getHostnameFromId.ts
var getHostnameFromId_exports2 = {};
__export(getHostnameFromId_exports2, {
  Error: () => Error127,
  Response: () => Response19
});
var Response19, Error127;
var init_getHostnameFromId2 = __esm({
  "src/serialization/resources/organization/client/getHostnameFromId.ts"() {
    "use strict";
    init_core();
    init_src();
    Response19 = schemas_exports.string();
    Error127 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organization.getHostnameFromId.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organization/client/getOrganizationFromHostName.ts
var getOrganizationFromHostName_exports2 = {};
__export(getOrganizationFromHostName_exports2, {
  Error: () => Error128
});
var Error128;
var init_getOrganizationFromHostName2 = __esm({
  "src/serialization/resources/organization/client/getOrganizationFromHostName.ts"() {
    "use strict";
    init_src();
    init_core();
    Error128 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.organization.getOrganizationFromHostName.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/organization/client/requests/GetOrganizationFromIdRequest.ts
var GetOrganizationFromIdRequest;
var init_GetOrganizationFromIdRequest = __esm({
  "src/serialization/resources/organization/client/requests/GetOrganizationFromIdRequest.ts"() {
    "use strict";
    init_core();
    GetOrganizationFromIdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/organization/client/requests/GetHostnameFromIdRequest.ts
var GetHostnameFromIdRequest;
var init_GetHostnameFromIdRequest = __esm({
  "src/serialization/resources/organization/client/requests/GetHostnameFromIdRequest.ts"() {
    "use strict";
    init_core();
    GetHostnameFromIdRequest = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Id)
    });
  }
});

// src/serialization/resources/organization/client/requests/GetOrganizationFromHostNameRequest.ts
var GetOrganizationFromHostNameRequest;
var init_GetOrganizationFromHostNameRequest = __esm({
  "src/serialization/resources/organization/client/requests/GetOrganizationFromHostNameRequest.ts"() {
    "use strict";
    init_core();
    GetOrganizationFromHostNameRequest = schemas_exports.object({
      hostname: schemas_exports.string()
    });
  }
});

// src/serialization/resources/organization/client/requests/index.ts
var init_requests13 = __esm({
  "src/serialization/resources/organization/client/requests/index.ts"() {
    "use strict";
    init_GetOrganizationFromIdRequest();
    init_GetHostnameFromIdRequest();
    init_GetOrganizationFromHostNameRequest();
  }
});

// src/serialization/resources/organization/client/index.ts
var init_client20 = __esm({
  "src/serialization/resources/organization/client/index.ts"() {
    "use strict";
    init_getOrganization4();
    init_getHostname2();
    init_getOrganizationFromId2();
    init_getHostnameFromId2();
    init_getOrganizationFromHostName2();
    init_requests13();
  }
});

// src/serialization/resources/organization/index.ts
var organization_exports2 = {};
__export(organization_exports2, {
  GetAllOrganizationsResponse: () => GetAllOrganizationsResponse,
  GetHostnameFromIdRequest: () => GetHostnameFromIdRequest,
  GetOrganizationFromHostNameRequest: () => GetOrganizationFromHostNameRequest,
  GetOrganizationFromIdRequest: () => GetOrganizationFromIdRequest,
  Organization: () => Organization,
  OrganizationInput: () => OrganizationInput,
  User: () => User,
  getHostname: () => getHostname_exports2,
  getHostnameFromId: () => getHostnameFromId_exports2,
  getOrganization: () => getOrganization_exports4,
  getOrganizationFromHostName: () => getOrganizationFromHostName_exports2,
  getOrganizationFromId: () => getOrganizationFromId_exports2
});
var init_organization2 = __esm({
  "src/serialization/resources/organization/index.ts"() {
    "use strict";
    init_types19();
    init_client20();
  }
});

// src/serialization/resources/video/resources/videoEdits/types/Version.ts
var Version2;
var init_Version2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/Version.ts"() {
    "use strict";
    init_core();
    Version2 = schemas_exports.enum_(["oct162023"]);
  }
});

// src/serialization/resources/video/resources/videoEdits/types/ZoomEdit.ts
var ZoomEdit;
var init_ZoomEdit2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/ZoomEdit.ts"() {
    "use strict";
    init_core();
    ZoomEdit = schemas_exports.object({
      startTime: schemas_exports.number(),
      endTime: schemas_exports.number(),
      zoomCenter: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Coordinates),
      zoomFactor: schemas_exports.number()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/Cover.ts
var Cover;
var init_Cover2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/Cover.ts"() {
    "use strict";
    init_core();
    Cover = schemas_exports.object({
      visible: schemas_exports.boolean(),
      duration: schemas_exports.number(),
      text1: schemas_exports.string().optional(),
      text2: schemas_exports.string().optional(),
      showLogo: schemas_exports.boolean().optional(),
      logoPosition: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Coordinates).optional(),
      logoSize: schemas_exports.number().optional(),
      intersectionDuration: schemas_exports.number().optional(),
      backgroundSrc: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/Background.ts
var Background;
var init_Background2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/Background.ts"() {
    "use strict";
    init_core();
    Background = schemas_exports.object({
      visible: schemas_exports.boolean(),
      padding: schemas_exports.number().optional(),
      borderRadius: schemas_exports.number().optional(),
      shadow: schemas_exports.number().optional(),
      src: schemas_exports.string().optional()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/VideoEdits.ts
var VideoEdits;
var init_VideoEdits2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/VideoEdits.ts"() {
    "use strict";
    init_core();
    VideoEdits = schemas_exports.object({
      version: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Version),
      voice: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).guides.Voice).optional(),
      intro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Cover).optional(),
      background: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Background).optional(),
      outro: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.Cover).optional(),
      zooms: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).video.ZoomEdit)).optional()
    });
  }
});

// src/serialization/resources/video/resources/videoEdits/types/index.ts
var init_types20 = __esm({
  "src/serialization/resources/video/resources/videoEdits/types/index.ts"() {
    "use strict";
    init_Version2();
    init_ZoomEdit2();
    init_Cover2();
    init_Background2();
    init_VideoEdits2();
  }
});

// src/serialization/resources/video/resources/videoEdits/index.ts
var videoEdits_exports2 = {};
__export(videoEdits_exports2, {
  Background: () => Background,
  Cover: () => Cover,
  Version: () => Version2,
  VideoEdits: () => VideoEdits,
  ZoomEdit: () => ZoomEdit
});
var init_videoEdits2 = __esm({
  "src/serialization/resources/video/resources/videoEdits/index.ts"() {
    "use strict";
    init_types20();
  }
});

// src/serialization/resources/video/resources/index.ts
var init_resources7 = __esm({
  "src/serialization/resources/video/resources/index.ts"() {
    "use strict";
    init_videoEdits2();
    init_types20();
  }
});

// src/serialization/resources/video/index.ts
var video_exports2 = {};
__export(video_exports2, {
  Background: () => Background,
  Cover: () => Cover,
  Version: () => Version2,
  VideoEdits: () => VideoEdits,
  ZoomEdit: () => ZoomEdit,
  videoEdits: () => videoEdits_exports2
});
var init_video2 = __esm({
  "src/serialization/resources/video/index.ts"() {
    "use strict";
    init_resources7();
  }
});

// src/serialization/resources/externalAuth/client/createToken.ts
var createToken_exports2 = {};
__export(createToken_exports2, {
  Error: () => Error129
});
var Error129;
var init_createToken2 = __esm({
  "src/serialization/resources/externalAuth/client/createToken.ts"() {
    "use strict";
    init_src();
    init_core();
    Error129 = schemas_exports.union("error", {
      UnauthorizedError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnauthorizedError":
            return api_exports.externalAuth.createToken.Error.unauthorizedError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/externalAuth/client/requests/CreateTokenRequest.ts
var CreateTokenRequest;
var init_CreateTokenRequest = __esm({
  "src/serialization/resources/externalAuth/client/requests/CreateTokenRequest.ts"() {
    "use strict";
    init_core();
    CreateTokenRequest = schemas_exports.object({
      username: schemas_exports.string()
    });
  }
});

// src/serialization/resources/externalAuth/client/requests/index.ts
var init_requests14 = __esm({
  "src/serialization/resources/externalAuth/client/requests/index.ts"() {
    "use strict";
    init_CreateTokenRequest();
  }
});

// src/serialization/resources/externalAuth/client/index.ts
var init_client21 = __esm({
  "src/serialization/resources/externalAuth/client/index.ts"() {
    "use strict";
    init_createToken2();
    init_requests14();
  }
});

// src/serialization/resources/externalAuth/index.ts
var externalAuth_exports2 = {};
__export(externalAuth_exports2, {
  CreateTokenRequest: () => CreateTokenRequest,
  createToken: () => createToken_exports2
});
var init_externalAuth2 = __esm({
  "src/serialization/resources/externalAuth/index.ts"() {
    "use strict";
    init_client21();
  }
});

// src/serialization/resources/healthcheck/client/healthcheck.ts
var healthcheck_exports3 = {};
__export(healthcheck_exports3, {
  Error: () => Error130
});
var Error130;
var init_healthcheck3 = __esm({
  "src/serialization/resources/healthcheck/client/healthcheck.ts"() {
    "use strict";
    init_src();
    init_core();
    Error130 = schemas_exports.union("error", {
      UnavailabilityError: schemas_exports.object({})
    }).transform({
      transform: (value) => {
        switch (value.error) {
          case "UnavailabilityError":
            return api_exports.healthcheck.healthcheck.Error.unavailabilityError();
        }
      },
      untransform: ({ _visit, ...value }) => value
    });
  }
});

// src/serialization/resources/healthcheck/client/index.ts
var init_client22 = __esm({
  "src/serialization/resources/healthcheck/client/index.ts"() {
    "use strict";
    init_healthcheck3();
  }
});

// src/serialization/resources/healthcheck/index.ts
var healthcheck_exports4 = {};
__export(healthcheck_exports4, {
  healthcheck: () => healthcheck_exports3
});
var init_healthcheck4 = __esm({
  "src/serialization/resources/healthcheck/index.ts"() {
    "use strict";
    init_client22();
  }
});

// src/serialization/resources/index.ts
var init_resources8 = __esm({
  "src/serialization/resources/index.ts"() {
    "use strict";
    init_analytics2();
    init_types11();
    init_audio2();
    init_types12();
    init_baseTypes2();
    init_types13();
    init_collections2();
    init_guides2();
    init_helpcenterQueries2();
    init_types18();
    init_organization2();
    init_types19();
    init_video2();
    init_externalAuth2();
    init_healthcheck4();
    init_requests8();
    init_requests14();
    init_requests12();
    init_requests13();
  }
});

// src/serialization/index.ts
var serialization_exports = {};
__export(serialization_exports, {
  CreateTokenRequest: () => CreateTokenRequest,
  DashboardToken: () => DashboardToken,
  EventsResponse: () => EventsResponse,
  FeedbackEvent: () => FeedbackEvent,
  GetAllOrganizationsResponse: () => GetAllOrganizationsResponse,
  GetChildrenRequest: () => GetChildrenRequest,
  GetGuideDataRequest: () => GetGuideDataRequest2,
  GetGuidePreviewRequest: () => GetGuidePreviewRequest2,
  GetHostnameFromIdRequest: () => GetHostnameFromIdRequest,
  GetOrganizationFromHostNameRequest: () => GetOrganizationFromHostNameRequest,
  GetOrganizationFromIdRequest: () => GetOrganizationFromIdRequest,
  GetTranscriptRequest: () => GetTranscriptRequest,
  GetVideoEditsRequest: () => GetVideoEditsRequest2,
  GuideRatedEvent: () => GuideRatedEvent,
  Id: () => Id2,
  IdRequest: () => IdRequest,
  InvalidSessionErrorBody: () => InvalidSessionErrorBody,
  Organization: () => Organization,
  OrganizationInput: () => OrganizationInput,
  PresignedUrl: () => PresignedUrl,
  S3Object: () => S3Object,
  SearchEvent: () => SearchEvent,
  SearchRequest: () => SearchRequest2,
  SimpleResponse: () => SimpleResponse,
  Token: () => Token,
  Transcript: () => Transcript,
  User: () => User,
  VideoFormat: () => VideoFormat,
  ViewEvent: () => ViewEvent,
  analytics: () => analytics_exports2,
  audio: () => audio_exports2,
  baseTypes: () => baseTypes_exports2,
  collections: () => collections_exports2,
  externalAuth: () => externalAuth_exports2,
  guides: () => guides_exports2,
  healthcheck: () => healthcheck_exports4,
  helpcenterQueries: () => helpcenterQueries_exports2,
  organization: () => organization_exports2,
  video: () => video_exports2
});
var init_serialization = __esm({
  "src/serialization/index.ts"() {
    "use strict";
    init_resources8();
  }
});

// src/api/resources/analytics/client/Client.ts
var import_url_join, Analytics;
var init_Client = __esm({
  "src/api/resources/analytics/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join = __toESM(require_url_join());
    init_serialization();
    Analytics = class {
      constructor(options) {
        this.options = options;
      }
      async getEventData() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/analytics/getEventData"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await EventsResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await analytics_exports2.getEventData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.analytics.getEventData.Error._unknown(_response.error)
        };
      }
      async getIdentity() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join.default)(this.options.environment, "/analytics/identity"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await DashboardToken.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        return {
          ok: false,
          error: api_exports.analytics.getIdentity.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/audio/client/Client.ts
var import_url_join2, Audio;
var init_Client2 = __esm({
  "src/api/resources/audio/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join2 = __toESM(require_url_join());
    init_serialization();
    Audio = class {
      constructor(options) {
        this.options = options;
      }
      async getTranscript(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join2.default)(this.options.environment, "/audio/getTranscript"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetTranscriptRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Transcript.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await audio_exports2.getTranscript.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.getTranscript.Error._unknown(_response.error)
        };
      }
      async saveAudio() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join2.default)(this.options.environment, "/audio/saveAudio"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await audio_exports2.saveAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.saveAudio.Error._unknown(_response.error)
        };
      }
      async saveGuideAudio(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join2.default)(this.options.environment, "/audio/saveGuideAudio"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await audio_exports2.saveGuideAudio.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.audio.saveGuideAudio.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/collections/resources/collectionMutations/client/Client.ts
var import_url_join3, CollectionMutations;
var init_Client3 = __esm({
  "src/api/resources/collections/resources/collectionMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join3 = __toESM(require_url_join());
    init_serialization();
    CollectionMutations = class {
      constructor(options) {
        this.options = options;
      }
      async createCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/createCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.CollectionInput.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.Collection.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.createCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.createCollection.Error._unknown(_response.error)
        };
      }
      async updateCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/updateCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.Collection.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.updateCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.updateCollection.Error._unknown(_response.error)
        };
      }
      async moveCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/moveCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.MoveCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.Collection.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.moveCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.moveCollection.Error._unknown(_response.error)
        };
      }
      async deleteCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/deleteCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.DeleteCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.deleteCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.deleteCollection.Error._unknown(_response.error)
        };
      }
      async reorderCollection(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/reorderCollection"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.ReorderCollectionRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.reorderCollection.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.reorderCollection.Error._unknown(_response.error)
        };
      }
      async setCollectionVisibility(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join3.default)(this.options.environment, "/collection_mutations/setCollectionVisibility"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await collections_exports2.SetCollectionVisibility.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionMutations.setCollectionVisibility.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionMutations.setCollectionVisibility.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/collections/resources/collectionQueries/client/Client.ts
var import_url_join4, CollectionQueries;
var init_Client4 = __esm({
  "src/api/resources/collections/resources/collectionQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join4 = __toESM(require_url_join());
    init_serialization();
    CollectionQueries = class {
      constructor(options) {
        this.options = options;
      }
      async getCollections(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/collection_queries/getCollections"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getCollections.Error._unknown(_response.error)
        };
      }
      async getAllChildren(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/collection_queries/getAllChildren"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetAllChildrenResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getAllChildren.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getAllChildren.Error._unknown(_response.error)
        };
      }
      async getAllCollections() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/collection_queries/getAllCollections"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.collectionQueries.getAllCollections.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getAllCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getAllCollections.Error._unknown(_response.error)
        };
      }
      async getPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join4.default)(this.options.environment, "/collection_queries/getPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await IdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await collections_exports2.collectionQueries.getPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.collections.collectionQueries.getPath.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/collections/client/Client.ts
var Collections;
var init_Client5 = __esm({
  "src/api/resources/collections/client/Client.ts"() {
    "use strict";
    init_Client3();
    init_Client4();
    Collections = class {
      constructor(options) {
        this.options = options;
      }
      _collectionMutations;
      get collectionMutations() {
        return this._collectionMutations ??= new CollectionMutations(this.options);
      }
      _collectionQueries;
      get collectionQueries() {
        return this._collectionQueries ??= new CollectionQueries(this.options);
      }
    };
  }
});

// src/api/resources/externalAuth/client/Client.ts
var import_url_join5, ExternalAuth;
var init_Client6 = __esm({
  "src/api/resources/externalAuth/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join5 = __toESM(require_url_join());
    init_serialization();
    ExternalAuth = class {
      constructor(options) {
        this.options = options;
      }
      async createToken(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join5.default)(this.options.environment, "/externalAuth/createToken"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await CreateTokenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Token.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await externalAuth_exports2.createToken.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.externalAuth.createToken.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideMutations/client/Client.ts
var import_url_join6, GuideMutations;
var init_Client7 = __esm({
  "src/api/resources/guides/resources/guideMutations/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join6 = __toESM(require_url_join());
    init_serialization();
    GuideMutations = class {
      constructor(options) {
        this.options = options;
      }
      async generateVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/generateVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GenerateVideoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.generateVideo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.generateVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.generateVideo.Error._unknown(_response.error)
        };
      }
      async generateEditedVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/generateEditedVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GenerateEditedVideoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.generateEditedVideo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.generateEditedVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.generateEditedVideo.Error._unknown(_response.error)
        };
      }
      async generateBookendsVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/generateBookendsVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GenerateBookendsVideoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.generateBookendsVideo.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.generateBookendsVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.generateBookendsVideo.Error._unknown(_response.error)
        };
      }
      async enhance(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/enhance"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PlainDocRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PlainDocRequest.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.enhance.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.enhance.Error._unknown(_response.error)
        };
      }
      async enhanceVideoTranscript(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/enhanceVideoTranscript"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PlainDocRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PlainDocRequest.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.enhanceVideoTranscript.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.enhanceVideoTranscript.Error._unknown(_response.error)
        };
      }
      async getLoomToken(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/getLoomToken"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: request
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.getLoomToken.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.getLoomToken.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.getLoomToken.Error._unknown(_response.error)
        };
      }
      async startCreateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/startCreateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.Guide.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PresignedUrlsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.startCreateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.startCreateGuide.Error._unknown(_response.error)
        };
      }
      async finishCreateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/finishCreateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishCreateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishCreateGuide.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishCreateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishCreateGuide.Error._unknown(_response.error)
        };
      }
      async initiateCreateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/initiateCreateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateCreateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateCreateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateCreateGuide.Error._unknown(_response.error)
        };
      }
      async initiateCreateVideoGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/initiateCreateVideoGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.InitiateCreateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.InitiateCreateVideoGuideResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.initiateCreateVideoGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.initiateCreateVideoGuide.Error._unknown(_response.error)
        };
      }
      async uploadImage(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/uploadImage"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Id2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.uploadImage.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.uploadImage.Error._unknown(_response.error)
        };
      }
      async uploadVideoChunk(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/uploadVideoChunk"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UploadChunkRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await PresignedUrl.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.uploadVideoChunk.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.uploadVideoChunk.Error._unknown(_response.error)
        };
      }
      async compileVideo(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/compileVideo"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CompileVideoRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.CompileVideoResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.compileVideo.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.compileVideo.Error._unknown(_response.error)
        };
      }
      async updateGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/updateGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.Guide.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.PresignedUrlsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateGuideData.Error._unknown(_response.error)
        };
      }
      async updateVideoEdits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/updateVideoEdits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.UpdateVideoEditsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateVideoEdits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateVideoEdits.Error._unknown(_response.error)
        };
      }
      async finishUpdateGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/finishUpdateGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.Guide.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUpdateGuideData.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUpdateGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUpdateGuideData.Error._unknown(_response.error)
        };
      }
      async createGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/createGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.Guide.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.createGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.createGuide.Error._unknown(_response.error)
        };
      }
      async createEmptyTextGuide(request = {}) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/createEmptyTextGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.CreateEmptyTextGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Id2.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.createEmptyTextGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.createEmptyTextGuide.Error._unknown(_response.error)
        };
      }
      async updateGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/updateGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GuidePreview.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.updateGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.updateGuidePreview.Error._unknown(_response.error)
        };
      }
      async pinGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/pinGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.PinGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.pinGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.pinGuide.Error._unknown(_response.error)
        };
      }
      async deleteGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/deleteGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DeleteGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.deleteGuide.Error._unknown(_response.error)
        };
      }
      async moveGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/moveGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.MoveGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.moveGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.moveGuide.Error._unknown(_response.error)
        };
      }
      async reorderGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/reorderGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ReorderGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await SimpleResponse.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.reorderGuide.Error._unknown(_response.error)
        };
      }
      async exportGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/exportGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ExportGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.ExportGuideResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.exportGuide.Error._unknown(_response.error)
        };
      }
      async convertToGif(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/convertToGif"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.ConvertToGif.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.convertToGif.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.convertToGif.Error._unknown(_response.error)
        };
      }
      async finishUploadVideoGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/finishUploadVideoGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.FinishUploadVideo.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideMutations.finishUploadVideoGuide.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.finishUploadVideoGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.finishUploadVideoGuide.Error._unknown(_response.error)
        };
      }
      async duplicateGuide(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join6.default)(this.options.environment, "/guide_mutations/duplicateGuide"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.DuplicateGuideRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideMutations.duplicateGuide.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideMutations.duplicateGuide.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/resources/guideQueries/client/Client.ts
var import_url_join7, GuideQueries;
var init_Client8 = __esm({
  "src/api/resources/guides/resources/guideQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join7 = __toESM(require_url_join());
    init_serialization();
    GuideQueries = class {
      constructor(options) {
        this.options = options;
      }
      async search(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/search"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.SearchRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.search.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.search.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.search.Error._unknown(_response.error)
        };
      }
      async getGuidePreviews(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/getGuidePreviews"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getAllGuidePreviews() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/getAllGuidePreviews"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.guideQueries.getAllGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getAllGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getAllGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/getGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuideDataRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuideData.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuideData.Error._unknown(_response.error)
        };
      }
      async getVideoEdits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/getVideoEdits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetVideoEditsRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await video_exports2.VideoEdits.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getVideoEdits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getVideoEdits.Error._unknown(_response.error)
        };
      }
      async getGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join7.default)(this.options.environment, "/guide_queries/getGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await guides_exports2.GetGuidePreviewRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await guides_exports2.guideQueries.getGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.guides.guideQueries.getGuidePreview.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/guides/client/Client.ts
var Guides;
var init_Client9 = __esm({
  "src/api/resources/guides/client/Client.ts"() {
    "use strict";
    init_Client7();
    init_Client8();
    Guides = class {
      constructor(options) {
        this.options = options;
      }
      _guideMutations;
      get guideMutations() {
        return this._guideMutations ??= new GuideMutations(this.options);
      }
      _guideQueries;
      get guideQueries() {
        return this._guideQueries ??= new GuideQueries(this.options);
      }
    };
  }
});

// src/api/resources/healthcheck/client/Client.ts
var import_url_join8, Healthcheck;
var init_Client10 = __esm({
  "src/api/resources/healthcheck/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join8 = __toESM(require_url_join());
    init_serialization();
    Healthcheck = class {
      constructor(options) {
        this.options = options;
      }
      async healthcheck() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join8.default)(this.options.environment, "/healthcheck"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnavailabilityError":
              return {
                ok: false,
                error: await healthcheck_exports4.healthcheck.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.healthcheck.healthcheck.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/helpcenterQueries/client/Client.ts
var import_url_join9, HelpcenterQueries;
var init_Client11 = __esm({
  "src/api/resources/helpcenterQueries/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join9 = __toESM(require_url_join());
    init_serialization();
    HelpcenterQueries = class {
      constructor(options) {
        this.options = options;
      }
      async validateToken(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/validateToken"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await Token.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.validateToken.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.validateToken.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.validateToken.Error._unknown(_response.error)
        };
      }
      async getOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Organization.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getOrganization.Error._unknown(_response.error)
        };
      }
      async search(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/search"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await SearchRequest2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.search.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.search.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.search.Error._unknown(_response.error)
        };
      }
      async getGuidePreviews(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getGuidePreviews"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getAllGuidePreviews() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getAllGuidePreviews"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getAllGuidePreviews.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllGuidePreviews.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllGuidePreviews.Error._unknown(_response.error)
        };
      }
      async getGuideData(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getGuideData"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetGuideDataRequest2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuideData.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuideData.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuideData.Error._unknown(_response.error)
        };
      }
      async getGuidePreview(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getGuidePreview"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetGuidePreviewRequest2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await guides_exports2.GuidePreview.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getGuidePreview.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getGuidePreview.Error._unknown(_response.error)
        };
      }
      async getVideoEdits(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getVideoEdits"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetVideoEditsRequest2.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await video_exports2.VideoEdits.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
            case "QueryFailedError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getVideoEdits.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getVideoEdits.Error._unknown(_response.error)
        };
      }
      async getCollections(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getCollections"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getCollections.Error._unknown(_response.error)
        };
      }
      async getAllChildren(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getAllChildren"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetChildrenRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetAllChildrenResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllChildren.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllChildren.Error._unknown(_response.error)
        };
      }
      async getAllCollections() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getAllCollections"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await helpcenterQueries_exports2.getAllCollections.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getAllCollections.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getAllCollections.Error._unknown(_response.error)
        };
      }
      async getPath(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join9.default)(this.options.environment, "/helpcenterQueries/getPath"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await IdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await collections_exports2.GetCollectionsResponse.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "InvalidSessionError":
              return {
                ok: false,
                error: await helpcenterQueries_exports2.getPath.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.helpcenterQueries.getPath.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/api/resources/organization/client/Client.ts
var import_url_join10, Organization2;
var init_Client12 = __esm({
  "src/api/resources/organization/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join10 = __toESM(require_url_join());
    init_serialization();
    Organization2 = class {
      constructor(options) {
        this.options = options;
      }
      async getOrganization() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/organization/getOrganization"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Organization.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await organization_exports2.getOrganization.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organization.getOrganization.Error._unknown(_response.error)
        };
      }
      async getHostname() {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/organization/getHostname"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organization_exports2.getHostname.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await organization_exports2.getHostname.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organization.getHostname.Error._unknown(_response.error)
        };
      }
      async getOrganizationFromId(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/organization/getOrganizationFromId"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetOrganizationFromIdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Organization.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await organization_exports2.getOrganizationFromId.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organization.getOrganizationFromId.Error._unknown(_response.error)
        };
      }
      async getHostnameFromId(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/organization/getHostnameFromId"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetHostnameFromIdRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await organization_exports2.getHostnameFromId.Response.parseOrThrow(
              _response.body,
              { allowUnknownKeys: true }
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await organization_exports2.getHostnameFromId.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organization.getHostnameFromId.Error._unknown(_response.error)
        };
      }
      async getOrganizationFromHostName(request) {
        const _response = await (this.options.fetcher ?? fetcher)({
          url: (0, import_url_join10.default)(this.options.environment, "/organization/getOrganizationFromHostName"),
          method: "POST",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await GetOrganizationFromHostNameRequest.jsonOrThrow(request)
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await Organization.parseOrThrow(_response.body, {
              allowUnknownKeys: true
            })
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.body?.error) {
            case "UnauthorizedError":
              return {
                ok: false,
                error: await organization_exports2.getOrganizationFromHostName.Error.parseOrThrow(
                  _response.error.body,
                  { allowUnknownKeys: true }
                )
              };
          }
        }
        return {
          ok: false,
          error: api_exports.organization.getOrganizationFromHostName.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/Client.ts
var GigaUserApiClient;
var init_Client13 = __esm({
  "src/Client.ts"() {
    "use strict";
    init_Client();
    init_Client2();
    init_Client5();
    init_Client6();
    init_Client9();
    init_Client10();
    init_Client11();
    init_Client12();
    GigaUserApiClient = class {
      constructor(options) {
        this.options = options;
      }
      _analytics;
      get analytics() {
        return this._analytics ??= new Analytics(this.options);
      }
      _audio;
      get audio() {
        return this._audio ??= new Audio(this.options);
      }
      _collections;
      get collections() {
        return this._collections ??= new Collections(this.options);
      }
      _externalAuth;
      get externalAuth() {
        return this._externalAuth ??= new ExternalAuth(this.options);
      }
      _guides;
      get guides() {
        return this._guides ??= new Guides(this.options);
      }
      _healthcheck;
      get healthcheck() {
        return this._healthcheck ??= new Healthcheck(this.options);
      }
      _helpcenterQueries;
      get helpcenterQueries() {
        return this._helpcenterQueries ??= new HelpcenterQueries(this.options);
      }
      _organization;
      get organization() {
        return this._organization ??= new Organization2(this.options);
      }
    };
  }
});

// src/index.ts
var init_src = __esm({
  "src/index.ts"() {
    init_api();
    init_Client13();
  }
});
init_src();
export {
  api_exports as GigaUserApi,
  GigaUserApiClient
};
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

basic-auth/index.js:
  (*!
   * basic-auth
   * Copyright(c) 2013 TJ Holowaychuk
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2015-2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
